export const raceOptions = [
  {
    name: "African American",
  },
  {
    name: "Alaskan Native",
  },
  {
    name: "American Indian",
  },
  {
    name: "Asian",
  },
  {
    name: "Black",
  },
  {
    name: "Native Hawaiian",
  },
  {
    name: "Native Pacific Islander",
  },
  {
    name: "White",
  },
];

export const ethnicityOptions = [
  { label: "Hispanic", value: "Hispanic" },
  { label: "Latino", value: "Latino" },
  { label: "Neither", value: "Non-Hispanic" },
];

export const ancestryOptions = [
  { value: "Acoma Pueblo" },
  { value: "Afghani" },
  { value: "African" },
  { value: "Alabama-Coushatta" },
  { value: "Albanian" },
  { value: "Apache" },
  { value: "Arabic" },
  { value: "Arapaho" },
  { value: "Arikara" },
  { value: "Armenian" },
  { value: "Arumanian" },
  { value: "Assiniboine" },
  { value: "Austrian" },
  { value: "Bamar" },
  { value: "Bangladeshi" },
  { value: "Barona Band of Mission Indians" },
  { value: "Bay Mills Indian Community" },
  { value: "Belgian" },
  { value: "Bengal" },
  { value: "Bengali" },
  { value: "Bhutanese" },
  { value: "Blackfeet" },
  { value: "Bohemian" },
  { value: "Bolivians" },
  { value: "Bosnian" },
  { value: "Brazilian" },
  { value: "British" },
  { value: "Caddo" },
  { value: "Cahuilla" },
  { value: "Cambodian" },
  { value: "Caribbean" },
  { value: "Catawba" },
  { value: "Cayuga" },
  { value: "Cayuse" },
  { value: "Chemehuevi" },
  { value: "Cherokee" },
  { value: "Cheyenne" },
  { value: "Chickahominy" },
  { value: "Chickasaw" },
  { value: "Chinese" },
  { value: "Chippewa" },
  { value: "Chitimacha" },
  { value: "Choctaws" },
  { value: "Chumash" },
  { value: "Cochiti Pueblo" },
  { value: "Cocopah" },
  { value: "Coeur d’Alene Tribe" },
  { value: "Colombian" },
  { value: "Comanche" },
  { value: "Confederated Tribes of Grand Ronde" },
  { value: "Confederated Tribes of the Colville Reservation" },
  { value: "Confederated Tribes of Warm Springs" },
  { value: "Coquille" },
  { value: "Coushatta" },
  { value: "Cowlitz" },
  { value: "Creek" },
  { value: "Croatian" },
  { value: "Crow" },
  { value: "Cuban" },
  { value: "Czech" },
  { value: "Danish" },
  { value: "Delaware Tribe" },
  { value: "Dominican" },
  { value: "Dutch" },
  { value: "Ecuadorian" },
  { value: "Egyptian" },
  { value: "English" },
  { value: "Estonian" },
  { value: "Ethiopian" },
  { value: "Fijian" },
  { value: "Filipino" },
  { value: "Finnish" },
  { value: "Fort Yuma Quechan" },
  { value: "French" },
  { value: "German" },
  { value: "Gila River Indian Community" },
  { value: "Grand Traverse Band of Ottawa & Chippewa Indians" },
  { value: "Greek" },
  { value: "Guatemalan" },
  { value: "Guyanese" },
  { value: "Haitian" },
  { value: "Hidatsa" },
  { value: "Hmong" },
  { value: "Ho Chunk" },
  { value: "Honduran" },
  { value: "Hoopa" },
  { value: "Hopi" },
  { value: "Hualapai" },
  { value: "Huguenot" },
  { value: "Hungarian" },
  { value: "Indian" },
  { value: "Indigenous Canadian" },
  { value: "Indigenous People (U.S.)" },
  { value: "Iowa Tribe of Kansas and Nebraska" },
  { value: "Iowa Tribe of Oklahoma" },
  { value: "Iranian" },
  { value: "Iraqi" },
  { value: "Irish" },
  { value: "Iroquois" },
  { value: "Isleta Pueblo" },
  { value: "Italian" },
  { value: "Jamaican" },
  { value: "Japanese" },
  { value: "Jemez Pueblo" },
  { value: "Jewish" },
  { value: "Karuk" },
  { value: "Kaw" },
  { value: "Kewa Pueblo" },
  { value: "Kickapoo Tribe in Kansas" },
  { value: "Klamath Tribes" },
  { value: "Kootenai" },
  { value: "Korean" },
  { value: "Laguna Pueblo" },
  { value: "Laotian" },
  { value: "Latvian" },
  { value: "Lebanese" },
  { value: "Libyan" },
  { value: "Lithuanian" },
  { value: "Little Traverse Bay Bands of Odawa Indians" },
  { value: "Lummi" },
  { value: "Macedonian" },
  { value: "Maidu" },
  { value: "Maldivian" },
  { value: "Maliseet" },
  { value: "Maltese" },
  { value: "Mandan" },
  { value: "Menominee" },
  { value: "Mexican" },
  { value: "Miami" },
  { value: "Miccosukee" },
  { value: "Micmacs" },
  { value: "Middle Eastern" },
  { value: "Modoc" },
  { value: "Mohave" },
  { value: "Mohawk" },
  { value: "Mohegans" },
  { value: "Mohican" },
  { value: "Mongolian" },
  { value: "Moravian" },
  { value: "Morongo" },
  { value: "Nambe Pueblo" },
  { value: "Narragansett" },
  { value: "Native Alaskan" },
  { value: "Native Guamanians" },
  { value: "Native Samoans" },
  { value: "Navajo" },
  { value: "Nepalese" },
  { value: "Nepali" },
  { value: "Nez Perce" },
  { value: "Nicaraguan" },
  { value: "Nigerian" },
  { value: "Norwegian" },
  { value: "Ohkay Owingeh Pueblo" },
  { value: "Ojibwe" },
  { value: "Oneida" },
  { value: "Onondaga" },
  { value: "Osage" },
  { value: "Otoe-Missouria" },
  { value: "Ottawa" },
  { value: "Paiute" },
  { value: "Pakistani" },
  { value: "Pamunkey" },
  { value: "Panamanian" },
  { value: "Passamaquoddy" },
  { value: "Pechanga" },
  { value: "Pennsylvania German" },
  { value: "Penobscot" },
  { value: "Peoria" },
  { value: "Pequot" },
  { value: "Peruvian" },
  { value: "Picuris Pueblo" },
  { value: "Pit River Tribe" },
  { value: "Pojoaque Pueblo" },
  { value: "Polish" },
  { value: "Ponca" },
  { value: "Poospatuck" },
  { value: "Portuguese" },
  { value: "Potawatomi" },
  { value: "Puerto Rican" },
  { value: "Quapaw" },
  { value: "Rappahannock" },
  { value: "Romanian" },
  { value: "Russian" },
  { value: "Ruthenian" },
  { value: "Sac and Fox Nation" },
  { value: "Salish" },
  { value: "Salvadoran" },
  { value: "Samish" },
  { value: "Samoan" },
  { value: "Sandia Pueblo" },
  { value: "San Filipe Pueblo" },
  { value: "San Ildefonso Pueblo" },
  { value: "Santa Ana Pueblo" },
  { value: "Santa Clara Pueblo" },
  { value: "Saponi" },
  { value: "Sault" },
  { value: "Scandinavian" },
  { value: "Scottish" },
  { value: "Seminole" },
  { value: "Seneca-Cayuga Tribe of Oklahoma" },
  { value: "Seneca Nation of Indians" },
  { value: "Serbian" },
  { value: "Shawnee" },
  { value: "Shinnecock" },
  { value: "Shoshone" },
  { value: "Sikhs" },
  { value: "Silesian" },
  { value: "Sioux" },
  { value: "Sisseton Wahpeton Oyate" },
  { value: "Slovak" },
  { value: "Slovene" },
  { value: "Snoqualmie" },
  { value: "Somalian" },
  { value: "South Asian" },
  { value: "Southeast Asian" },
  { value: "Spanish" },
  { value: "Spirit Lake Tribe" },
  { value: "Spokane" },
  { value: "Sri Lankan" },
  { value: "St. Regis" },
  { value: "Sudanese" },
  { value: "Swedish" },
  { value: "Swiss" },
  { value: "Syrian" },
  { value: "Taiwanese" },
  { value: "Taos Pueblo" },
  { value: "Tesuque Pueblo" },
  { value: "Thai" },
  { value: "Tohono O’odham" },
  { value: "Tongan" },
  { value: "Tonkawa" },
  { value: "Trinidadian" },
  { value: "Tulalip" },
  { value: "Tunica Biloxi" },
  { value: "Turkish" },
  { value: "Tuscarora" },
  { value: "Ukrainian" },
  { value: "Umatilla" },
  { value: "Umpqua" },
  { value: "Ute" },
  { value: "Vietnamese" },
  { value: "Walla Walla" },
  { value: "Wampanoag (Aquinnah)" },
  { value: "Wanapum" },
  { value: "Washoe" },
  { value: "Welsh" },
  { value: "West Asian" },
  { value: "Wichita" },
  { value: "Winnebago" },
  { value: "Wyandotte" },
  { value: "Yakama" },
  { value: "Yaqui" },
  { value: "Yavapai" },
  { value: "Yemeni" },
  { value: "Ysleta del Sur Pueblo" },
  { value: "Yugoslavian" },
  { value: "Yurok" },
  { value: "Zia Pueblo" },
  { value: "Zuni Pueblo" },
];
export const genderOptions = [
  { value: "Woman" },
  { value: "Man" },
  { value: "Trans woman" },
  { value: "Trans man" },
  { value: "Non-binary/non-conforming" },
  { value: "Two spirit" },
  { value: "Intersex" },
  { value: "Prefer not to respond" },
];
export const sexualityOptions = [
  { value: "Straight/Heterosexual" },
  { value: "Gay" },
  { value: "Lesbian" },
  { value: "Asexual" },
  { value: "Bisexual" },
  { value: "Pansexual" },
  { value: "Other" },
  { value: "Prefer not to respond" },
];
export const citizenStatusOptions = [
  { value: "U.S. Citizen" },
  { value: "Permanent Resident" },
  { value: "Conditional Permanent Resident" },
  { value: "Current DACA Status" },
  { value: "Pending DACA Application" },
  { value: "FAFSA-Eligible Non-Citizen" },
  { value: "Not a U.S. Citizen" },
  { value: "Asylum-Seeker or Asylee" },
  { value: "Cuban or Haitian Entrant" },
  { value: "Humanitarian Parolee" },
  { value: "Refugee" },
  { value: "California AB 540" },
]; // https://gist.githubusercontent.com/marshallswain/88f377c71aa88aceaf660b157f6d8f46/raw/599592776eb9c25d59de175e4438898a66f8a290/states.js
export const stateAbbrOptions = [
  { name: "ALABAMA", value: "AL" },
  { name: "ALASKA", value: "AK" },
  { name: "AMERICAN SAMOA", value: "AS" },
  { name: "ARIZONA", value: "AZ" },
  { name: "ARKANSAS", value: "AR" },
  { name: "CALIFORNIA", value: "CA" },
  { name: "COLORADO", value: "CO" },
  { name: "CONNECTICUT", value: "CT" },
  { name: "DELAWARE", value: "DE" },
  { name: "DISTRICT OF COLUMBIA", value: "DC" },
  { name: "FEDERATED STATES OF MICRONESIA", value: "FM" },
  { name: "FLORIDA", value: "FL" },
  { name: "GEORGIA", value: "GA" },
  { name: "GUAM", value: "GU" },
  { name: "HAWAII", value: "HI" },
  { name: "IDAHO", value: "ID" },
  { name: "ILLINOIS", value: "IL" },
  { name: "INDIANA", value: "IN" },
  { name: "IOWA", value: "IA" },
  { name: "KANSAS", value: "KS" },
  { name: "KENTUCKY", value: "KY" },
  { name: "LOUISIANA", value: "LA" },
  { name: "MAINE", value: "ME" },
  { name: "MARSHALL ISLANDS", value: "MH" },
  { name: "MARYLAND", value: "MD" },
  { name: "MASSACHUSETTS", value: "MA" },
  { name: "MICHIGAN", value: "MI" },
  { name: "MINNESOTA", value: "MN" },
  { name: "MISSISSIPPI", value: "MS" },
  { name: "MISSOURI", value: "MO" },
  { name: "MONTANA", value: "MT" },
  { name: "NEBRASKA", value: "NE" },
  { name: "NEVADA", value: "NV" },
  { name: "NEW HAMPSHIRE", value: "NH" },
  { name: "NEW JERSEY", value: "NJ" },
  { name: "NEW MEXICO", value: "NM" },
  { name: "NEW YORK", value: "NY" },
  { name: "NORTH CAROLINA", value: "NC" },
  { name: "NORTH DAKOTA", value: "ND" },
  { name: "NORTHERN MARIANA ISLANDS", value: "MP" },
  { name: "OHIO", value: "OH" },
  { name: "OKLAHOMA", value: "OK" },
  { name: "OREGON", value: "OR" },
  { name: "PALAU", value: "PW" },
  { name: "PENNSYLVANIA", value: "PA" },
  { name: "PUERTO RICO", value: "PR" },
  { name: "RHODE ISLAND", value: "RI" },
  { name: "SOUTH CAROLINA", value: "SC" },
  { name: "SOUTH DAKOTA", value: "SD" },
  { name: "TENNESSEE", value: "TN" },
  { name: "TEXAS", value: "TX" },
  { name: "UTAH", value: "UT" },
  { name: "VERMONT", value: "VT" },
  { name: "VIRGIN ISLANDS", value: "VI" },
  { name: "VIRGINIA", value: "VA" },
  { name: "WASHINGTON", value: "WA" },
  { name: "WEST VIRGINIA", value: "WV" },
  { name: "WISCONSIN", value: "WI" },
  { name: "WYOMING", value: "WY" },
]; //https://gist.github.com/tleen/6395808?permalink_comment_id=2258052#gistcomment-2258052
export const canadianProvincesOptions = [
  { name: "Alberta", value: "AB" },
  { name: "British Columbia", value: "BC" },
  { name: "Manitoba", value: "MB" },
  { name: "New Brunswick", value: "NB" },
  { name: "Newfoundland and Labrador", value: "NL" },
  { name: "Northwest Territories", value: "NT" },
  { name: "Nova Scotia", value: "NS" },
  { name: "Nunavut", value: "NU" },
  { name: "Ontario", value: "ON" },
  { name: "Prince Edward Island", value: "PE" },
  { name: "Quebec", value: "QC" },
  { name: "Saskatchewan", value: "SK" },
  { name: "Yukon Territory", value: "YT" },
];
// https://css-tricks.com/snippets/javascript/array-of-country-names/
export const countryOptions = [
  { label: "United States", value: "US" },
  { label: "Afghanistan", value: "AF" },
  { label: "land Islands", value: "AX" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "American Samoa", value: "AS" },
  { label: "AndorrA", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Anguilla", value: "AI" },
  { label: "Antarctica", value: "AQ" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Aruba", value: "AW" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bermuda", value: "BM" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Bouvet Island", value: "BV" },
  { label: "Brazil", value: "BR" },
  { label: "British Indian Ocean Territory", value: "IO" },
  { label: "Brunei Darussalam", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Cape Verde", value: "CV" },
  { label: "Cayman Islands", value: "KY" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Christmas Island", value: "CX" },
  { label: "Cocos (Keeling) Islands", value: "CC" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo", value: "CG" },
  { label: "Congo, The Democratic Republic of the", value: "CD" },
  { label: "Cook Islands", value: "CK" },
  { label: "Costa Rica", value: "CR" },
  { label: "Cote D'Ivoire", value: "CI" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Ethiopia", value: "ET" },
  { label: "Falkland Islands (Malvinas)", value: "FK" },
  { label: "Faroe Islands", value: "FO" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "French Guiana", value: "GF" },
  { label: "French Polynesia", value: "PF" },
  { label: "French Southern Territories", value: "TF" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Gibraltar", value: "GI" },
  { label: "Greece", value: "GR" },
  { label: "Greenland", value: "GL" },
  { label: "Grenada", value: "GD" },
  { label: "Guadeloupe", value: "GP" },
  { label: "Guam", value: "GU" },
  { label: "Guatemala", value: "GT" },
  { label: "Guernsey", value: "GG" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Heard Island and Mcdonald Islands", value: "HM" },
  { label: "Holy See (Vatican City State)", value: "VA" },
  { label: "Honduras", value: "HN" },
  { label: "Hong Kong", value: "HK" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran, Islamic Republic Of", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Isle of Man", value: "IM" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jersey", value: "JE" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Korea, Democratic People's Republic of", value: "KP" },
  { label: "Korea, Republic of", value: "KR" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Lao People'S Democratic Republic", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libyan Arab Jamahiriya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Macao", value: "MO" },
  { label: "Macedonia, The Former Yugoslav Republic of", value: "MK" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Martinique", value: "MQ" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mayotte", value: "YT" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia, Federated States of", value: "FM" },
  { label: "Moldova, Republic of", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Montserrat", value: "MS" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "Netherlands Antilles", value: "AN" },
  { label: "New Caledonia", value: "NC" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "Niue", value: "NU" },
  { label: "Norfolk Island", value: "NF" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestinian Territory, Occupied", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Pitcairn", value: "PN" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Qatar", value: "QA" },
  { label: "Reunion", value: "RE" },
  { label: "Romania", value: "RO" },
  { label: "Russian Federation", value: "RU" },
  { label: "RWANDA", value: "RW" },
  { label: "Saint Helena", value: "SH" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Pierre and Miquelon", value: "PM" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Georgia and the South Sandwich Islands", value: "GS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Surilabel", value: "SR" },
  { label: "Svalbard and Jan Mayen", value: "SJ" },
  { label: "Swaziland", value: "SZ" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syrian Arab Republic", value: "SY" },
  { label: "Taiwan, Province of China", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania, United Republic of", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tokelau", value: "TK" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Turks and Caicos Islands", value: "TC" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States Minor Outlying Islands", value: "UM" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Venezuela", value: "VE" },
  { label: "Viet Nam", value: "VN" },
  { label: "Virgin Islands, British", value: "VG" },
  { label: "Virgin Islands, U.S.", value: "VI" },
  { label: "Wallis and Futuna", value: "WF" },
  { label: "Western Sahara", value: "EH" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];
export const countryOptionNames = countryOptions.map(({ value }) => value);
export const collegeReadinessProgramList = [
  "10,000 Degrees",
  "100 Black Men",
  "Academy for Technology and the Classics",
  "A Call to College",
  "ACCESS College Foundation",
  "Access Opportunity",
  "AchieveMpls",
  "Achieve Program",
  "Achievers by Choice",
  "Achieving a College Education",
  "¡Adelante Latina!",
  "Advance! ... on to College",
  "Advise TX",
  "After School Matters",
  "AGUILA Youth Leadership Institute",
  "Alive & Free College Prep Program",
  "Alliance",
  "Al Wooten Jr. Heritage Center College Trek",
  "APEX for Youth",
  "AP Strategies",
  "Arizona State University CAMP Scholars Project",
  "ASPIRA",
  "ASPIRE",
  "AVID",
  "AVID Pojoaque",
  "AVID Santa Fe",
  "Baltimore Educational Scholarship Trust Program",
  "Barrio Logan College Institute College Success Program",
  "Be A Leader Foundation College Success Program",
  "Boston Higher Education Resource Center Passport Program",
  "Bottom Line",
  "Boys & Girls Club Diplomas 2 Degrees Program",
  "Boys Hope Girls Hope College Road",
  "Breakthrough",
  "Breakthrough Atlanta",
  "Breakthrough Austin",
  "Breakthrough Cincinnati",
  "Breakthrough Greater Boston",
  "Breakthrough Houston",
  "Breakthrough New York",
  "Breakthrough Santa Fe",
  "Breakthrough Silicon Valley",
  "Breakthrough Twin Cities",
  "Bridges to a Brighter Future",
  "Bridges to Success",
  "Bridging the Gap",
  "Brighten Your Future",
  "Buffalo Prep",
  "Burmese American Community Institute",
  "Cal-SOAP",
  "Career & College Clubs",
  "Casita Maria College Bound Program",
  "C-CAP",
  "Center for Leadership Development College Prep Institute",
  "Chicago Math and Science Academy College Preparation Program",
  "Chicago Scholars",
  "Chicago Urban League Project Ready",
  "College Access Center",
  "College Advising Corps",
  "College AIM",
  "College and Career Pathways",
  "College Bound",
  "College Bound Opportunities",
  "College Community Career",
  "College Crusade of Rhode Island",
  "College Depot",
  "College Dreams College and Career Incentive Program",
  "College Forward",
  "College Horizons",
  "College Knowledge Project",
  "College Match",
  "College Now",
  "College Possible",
  "College Possible Washington",
  "College Preparatory Program (Any)",
  "College Reach Out Program",
  "College Readiness Program (Any)",
  "College Success Foundation DC Scholars Program",
  "College Track",
  "CollegeTracks",
  "College Visions",
  "Communities in Schools",
  "Con Mi Madre",
  "ConnCAP",
  "Connecticut Talent Assistance Cooperative",
  "Coshocton C.A.R.E.S.",
  "Council of African American Parents Personal Academic Learning System Program",
  "Cristo Rey Network",
  "Crosby Scholar",
  "Daniel Murphy Scholarship Fund College Counseling",
  "DC College Access Program",
  "DC Prep PrepNext",
  "Delmarva Education Foundation College Access Program",
  "DiscoverU",
  "EAGLE Scholars Program",
  "Earl Woods Scholars Program",
  "East Bay College Fund Mentorship Program",
  "East Bay Consortium of Educational Institutions Pre-Collegiate Academy",
  "East Harlem Tutorial Program College Scholars",
  "East Village Youth College Program",
  "Educational Talent Search",
  "Education is Freedom",
  "Elon Academy College Access Program",
  "ENLACE",
  "FACES for the Future",
  "FAME Academy",
  "First Graduate",
  "First Year Experience",
  "For Love of Children City Leaders Program",
  "Foundation for a College Education College Success Program",
  "Fulfillment Fund",
  "Gads Hill Center Building Leaders",
  "GEAR UP",
  "Genesys Works",
  "Georgetown University Institute for College Preparation",
  "Get 2 College",
  "Get Me to College",
  "Girls Write Now Writing Works Program",
  "Goddard Riverside Options Center",
  "Golden Scholars",
  "Green Dot",
  "Greenhouse Scholars",
  "Guided Pathways Support Program",
  "HACE El Futuro Program",
  "Headwaters Next Step Program",
  "Heart of Los Angeles College and Career Success Program",
  "Hetrick-Martin Institute Academic Enrichment Program",
  "Hidden Genius Project",
  "Higher Edge",
  "Higher Heights Youth Empowerment College Access Programs",
  "HighSight College Readiness",
  "HISD Emerge",
  "Honickman Learning Center College Access Program",
  "Horizons for Youth",
  "HYPE",
  "IDEA Academy",
  "I Have a Dream Foundation University Prep",
  "I Know I Can",
  "I-LEAD",
  "iMentor",
  "Indiana Latino Institute",
  "Johns Hopkins Center for Talented Youth Scholars Program",
  "Kauffman Scholars",
  "KIPP",
  "KIPP Through College",
  "La Plaza",
  "Latin American Educational Foundation College Access and Success Program",
  "La Vida Scholars",
  "Leap 4 Education College Success Program",
  "Let's Get Ready",
  "Mahoning Valley College Access Program",
  "Making Waves College & Alumni Program",
  "Marwen College & Career Programs",
  "Mastery Charter Schools",
  "McNair Scholars Program",
  "Metro Squash",
  "Minds Matter",
  "Mission Graduates College Connect",
  "My Brother's Keeper Austin",
  "NACA Inspired Schools Network",
  "National Math and Science Initiative",
  "Navajo Prep",
  "Neighborhood House College Readiness Academy",
  "New Mexico School for the Arts",
  "New York Urban League Absolute Success College Access Program",
  "Nicholas Academic Center Higher Education Services",
  "Noble Network",
  "None",
  "Northwest Association of Educational Opportunity Programs (NAEOP-TRIO)",
  "One Goal",
  "On Point for College",
  "Operation Jump Start",
  "Opportunity Network Fellows Program",
  "PACE",
  "Partnership for the Future",
  "Partnership Scholars Program",
  "Pass with Flying Colors College Ready and College Success Programs",
  "Pathways to College Scholars Program",
  "Peak Education Program",
  "Peer Forward",
  "Peninsula Bridge",
  "Pennsylvania College Access Program",
  "Philadelphia Futures",
  "Point Foundation Mentoring Program",
  "Posse Foundation",
  "Posse Scholars",
  "Postsecondary and Career Expectations",
  "Princeton University Preparatory Program",
  "Project Discovery Scholars Program",
  "Project GRAD",
  "Project Lead the Way",
  "Project MALES",
  "Project Youth OCBF Higher Education Mentoring Program",
  "Reality Changers",
  "Riis Settlement College Access Program",
  "Roaring Fork Precollegiate",
  "Rural Scholars Program",
  "Rutgers Future Scholars Program",
  "SAYA! College Access Program",
  "Scholars’ Hope",
  "Schuler Scholars Program",
  "Scripps College Academy",
  "SCS Noonan Scholars",
  "Seattle Education Access College Prep Program",
  "SEED Academy",
  "Seminole Tribe Higher Education Program",
  "SEO Scholars",
  "Simmons Memorial Foundation 3PI Mentoring Program",
  "Simon Scholars",
  "SMART College Achievement Program",
  "SMASH Academy",
  "South Valley Academy",
  "Starfish Scholars",
  "Steppingstone Scholars",
  "Stevens Technical Enrichment Program",
  "Student Support Services",
  "Summer Bridge",
  "Summer Search",
  "Teak Fellowship",
  "TeenWorks",
  "The Bridge Project",
  "The Door College Paths",
  "The Excel Center",
  "The MASTERS Program",
  "The Opportunity Network",
  "Think Together",
  "Tipton County College Access Program",
  "TRIO",
  "Tu Futuro",
  "Uncommon Schools",
  "Unidos Now",
  "United Friends Scholars",
  "¡Universidad Ya!",
  "Uplift Education",
  "Upward Bound",
  "Upward Bound Espanola",
  "Upward Bound Math-Science",
  "Upward Bound Program",
  "Urban League",
  "Urban Mission Y",
  "Urban Scholars Program",
  "USC Bovard Scholars Program",
  "UT Outreach",
  "Veterans Upward Bound",
  "VIDAL Access",
  "Waukegan to College",
  "YES Prep",
  "YMCA Black & Latino Achievers Program",
  "Young Eisner Scholars",
  "Young Life",
  "Young Men and Women in Charge",
  "Young Scholars Program",
  "Youth Leadership Tomorrow",
];
export const schoolTypes = [
  {
    value: "College",
  },
  {
    value: "Elementary school",
  },
  {
    value: "Middle school",
  },
  {
    value: "High school",
  },
  {
    value: "Technical school",
  },
  {
    value: "University",
  },
  {
    value: "Home school",
  },
  {
    value: "Graduate school",
  },
];
export const scholarshipPurposeOptions = [
  { value: "Certificate program" },
  { value: "Graduate program" },
  { value: "Professional Certification" },
  { value: "1-year Certificate" },
  { value: "Associate Degree" },
  { value: "Bachelor's Degree" },
  { value: "Graduate Degree" },
  { value: "Doctor of Medicine" },
  { value: "Law Degree" },
  { value: "MBA" },
  { value: "MFA" },
  { value: "PhD" },
];

export const activityOptions = [
  "None",
  "Academic Activities",
  "Academic Club",
  "Academic Decathlon",
  "Acting",
  "Advocacy",
  "Amateur Radio",
  "Animal Rescue Group",
  "Archery",
  "Architecture",
  "Aviation",
  "Badminton",
  "Ballet",
  "Band",
  "Baseball",
  "Basketball",
  "Biathlon",
  "Billiards",
  "BMX",
  "Bodybuilding",
  "Bowling",
  "Boxing",
  "Brass Instrument",
  "Bridge",
  "Caddying",
  "Call Of Duty League",
  "Canadian Football",
  "Canoeing",
  "CAPA Program",
  "Ceramics",
  "Checkers",
  "Cheerleading",
  "Chess",
  "Choir",
  "Chorus",
  "Christian Youth Group",
  "Church Activities",
  "Church Service",
  "Civic Engagement",
  "Civic Group Participation",
  "Classified Student Service Assistant",
  "Coin Collecting",
  "College Bowl",
  "Color Guard",
  "Community Organizing",
  "Community Service",
  "Composing",
  "Console Gaming",
  "Creative Writing",
  "Crew",
  "Cricket",
  "Cross Country Running",
  "Cross Country Skiing",
  "CS:GO Esports",
  "Curling",
  "Cycling",
  "Dance",
  "Darts",
  "Debate",
  "Disc Golf",
  "Diving",
  "Documentary Filmmaking",
  "Dog Raising",
  "DOTA 2 Esports",
  "Downhill Skiing",
  "Drawing",
  "Dressage",
  "Drift Racing",
  "Duck Calling",
  "Entrepreneurship",
  "Environmental Cleanup Projects",
  "Environmental Club",
  "Envirothon",
  "Equestrian Sports",
  "Esports",
  "Extracurricular Activities",
  "Fantasy Football",
  "Farming",
  "Fencing",
  "Fiction",
  "Field Hockey",
  "FIFA Esports",
  "Film Editing",
  "Filmmaking",
  "Football",
  "Fortnite Esports",
  "Games",
  "Gardening",
  "Genealogy",
  "Go",
  "Go-Kart Racing",
  "Golf",
  "Guitar",
  "Gymnastics",
  "Healthcare Internships",
  "Hearthstone Esports",
  "Heroes of the Storm Esports",
  "Hiking",
  "Hobbies",
  "Hockey",
  "Hunting",
  "Ice Hockey",
  "Ice Skating",
  "Inventing",
  "Jazz Band",
  "Jogging",
  "Judo",
  "Kayaking",
  "Lacrosse",
  "Land Conservancy",
  "Latin Club",
  "Leadership",
  "League of Legends Esports",
  "Literary Arts",
  "Madden Esports",
  "Magic: The Gathering",
  "Marching Band",
  "Marksmanship",
  "Martial Arts",
  "Math League",
  "Mentorship of Athletes",
  "Mock Trial",
  "Model United Nations",
  "Modern Dance",
  "Moot Court",
  "Mortal Kombat Esports",
  "Motorcycling",
  "Motorsports",
  "Mountain Climbing",
  "Music",
  "Musical Instruments",
  "Musical Theater",
  "Off-Road Vehicles",
  "Oil Painting",
  "Opera",
  "Oration",
  "Orchestra",
  "Overwatch Esports",
  "Painting",
  "Paladins Esports",
  "PC Gaming",
  "Performing Arts",
  "Photography",
  "Piano",
  "Pickleball",
  "Playwriting",
  "Poetry",
  "Political Campaigning",
  "Private Music Study",
  "Prose",
  "PUBG Esports",
  "Puppetry",
  "Puzzles",
  "Quiz Bowl",
  "Racquetball",
  "Reading",
  "Recycling",
  "Religious Activities",
  "Riflery",
  "Ringette",
  "Robotics",
  "Rock Climbing",
  "Rocket League Esports",
  "Rodeo",
  "Roller Skating",
  "Rugby",
  "Sailing",
  "Science Fair",
  "Sculpting",
  "Set Design",
  "Shooting",
  "Singing",
  "Skateboarding",
  "Skiing",
  "Smite Esports",
  "Snowboarding",
  "Snowmobiling",
  "Soap Box Derby",
  "Soccer",
  "Softball",
  "Spoken Word",
  "Sports",
  "Squash",
  "Stamp Collecting",
  "StarCraft II Esports",
  "Startup Company",
  "Street Fighter Esports",
  "Strength and Conditioning",
  "Student Government",
  "Student Newspaper",
  "Student Radio",
  "Super Smash Bros. Ultimate Esports",
  "Surfing",
  "Swimming",
  "Synchronized Swimming",
  "Table Tennis",
  "Tabletop Games",
  "Taekwondo",
  "Teaching Assistant",
  "Technology Club",
  "Teen Court",
  "Tennis",
  "Theater Arts",
  "Track and Field",
  "Translating",
  "Triathlon",
  "Tutoring",
  "UIL Academics",
  "Ultimate Frisbee",
  "Varsity Sport",
  "Video Editing",
  "Video Games",
  "Visual Arts",
  "Volleyball",
  "Watercolor Painting",
  "Water Polo",
  "Water Skiing",
  "Weightlifting",
  "Work",
  "Worship",
  "Wrestling",
  "Writing",
  "Writing Nonfiction",
  "Writing Novels",
  "Writing Science Fiction",
  "Writing Short Stories",
  "Yearbook",
];

export const interestOptions = [
  "Agriculture",
  "Art",
  "Aviation",
  "Broadcasting",
  "Broadcast Journalism",
  "Building Trades",
  "Business",
  "Chemistry",
  "Communications",
  "Construction",
  "Culinary Arts",
  "Diversity",
  "Drumming",
  "Entertainment",
  "Entrepreneurship",
  "Environmentalism",
  "First Aid",
  "Forensics",
  "Gardening",
  "Golf",
  "Government",
  "Health",
  "Health Research",
  "Healthy Living",
  "History",
  "Horticulture",
  "Human Resources",
  "International Travel",
  "Jazz",
  "Leadership",
  "Literature",
  "Media",
  "Motorcycling",
  "Music",
  "Nature",
  "Occupational Safety Training",
  "Online Entrepreneurship",
  "Outdoor Activities",
  "Performing and Theatrical Arts",
  "Poetry",
  "Political Science",
  "Public Affairs",
  "Public Service",
  "Racial Equality",
  "Real Estate",
  "Running",
  "Science",
  "Social Justice",
  "Special Event and Tent Industry",
  "Sports",
  "Startup Company",
  "Study Abroad",
  "Teaching",
  "Theater",
  "Truck Driving",
  "Welding",
  "Wildlife Conservation",
  "Writing",
];

export const graduationTypeOptions = [
  "Certificate program",
  "High school",
  "2-year program",
  "4-year program",
  "High school equivalence (GED) program",
  "Graduate program",
  "Home school program",
  "Community College Freshman",
  "Community College Sophomore",
  "College Freshman",
  "College Sophomore",
];

export const gradeLevelOptions = [
  "High School Freshman",
  "High School Sophomore",
  "High School Junior",
  "High School Senior",
  "Community College Freshman",
  "Community College Freshman - Attended College Previously",
  "Community College Sophomore",
  "College Freshman",
  "College Freshman - Attended College Previously",
  "College Sophomore",
  "College Junior",
  "College Senior",
  "5th Year College Undergraduate",
  "Nth Year College Undergraduate",
  "Graduate Student",
  "Doctoral Candidate",
  "Postgraduate Medical School",
  "Postgraduate Law School",
  "Not Enrolled",
  "On Academic Break",
];

export const testTypeOptions = [
  "SAT Total",
  "SAT Math",
  "SAT Evidence-Based Reading and Writing",
  "SAT Essay Reading",
  "SAT Essay Analysis",
  "SAT Essay Writing",
  "ACT Composite",
];

export const enrollmentStatusOptions = [
  {
    value: "Full-Time",
    label: "Full-Time",
  },
  {
    value: "Part-Time",
    label: "Part-Time",
  },
];
export const medicalConditions = [
  "ADD",
  "Addiction",
  "ADHD",
  "Alcoholism",
  "ALS",
  "Alzheimer’s Disease",
  "Aplastic Anemia",
  "Arthritis",
  "Asperger’s Syndrome",
  "Asthma",
  "Autism",
  "Behavioral Health",
  "Bipolar Disorder",
  "Black Lung Disease",
  "Blindness",
  "Blood Disorder",
  "Bone Tumors or Disease",
  "Brain Tumor",
  "Breast Cancer",
  "Burn Survivor",
  "Cancer",
  "Celiac Disease",
  "Cerebral Palsy",
  "Charcot-Marie-Tooth Disease",
  "Chronic Disease",
  "Chronic Fatigue Syndrome",
  "Cleft Palate",
  "Completed a Rehabilitation Program",
  "Cooley’s Anemia",
  "Craniofacial Conditions",
  "Crohn's Disease",
  "Cystic Fibrosis",
  "Cystinosis",
  "Deafness",
  "Developmental Disability",
  "Diabetes",
  "Disability",
  "Down Syndrome",
  "Dwarfism",
  "Dyslexia",
  "Ectodermal Dysplasias",
  "Epilepsy",
  "Gastrointestinal Disease",
  "Gaucher Disease",
  "Glycogen Storage Disease",
  "Hansen’s Disease",
  "Hard of Hearing",
  "Hearing-Impaired",
  "Heart Disease",
  "Hemiparesis",
  "Hemiplegia",
  "Hemophilia",
  "Hepatitis",
  "HIV",
  "Hydrocephalus",
  "Inflammatory Disease",
  "Injury at Birth",
  "Injury from Burns",
  "Injury from Car Accident",
  "Kidney Disease",
  "Learning Disability",
  "Left-Handedness",
  "Legally Blind",
  "Leukemia",
  "Limb Deformity",
  "Low Vision",
  "Lupus",
  "Lyme Disease",
  "Lymphoma",
  "Lysosomal Storage Disease",
  "MDS",
  "Missing Limb",
  "Mortal Disease",
  "Multiple Sclerosis",
  "Muscular Dystrophy",
  "Neurological Disabilities",
  "Non-Drinker",
  "Non-Smoker",
  "Nutcracker Syndrome",
  "Nystagmus",
  "Organ Transplant",
  "Orthopedic Impairment",
  "Osteogenesis Imperfecta",
  "Paralysis",
  "Paraplegia",
  "Parkinson's Disease",
  "Phenylketonuria",
  "Physical Disability",
  "Platelet Disorder",
  "PNH",
  "Polio",
  "Pregnant",
  "Primary Immune Deficiency Disease",
  "Psoriasis",
  "Quadriplegia",
  "Recovered from Addiction",
  "Recovered from Alcoholism",
  "Respiratory Disease",
  "Rheumatic Disease",
  "Rheumatoid Arthritis",
  "Schizoaffective Disorder",
  "Schizophrenia",
  "Severe Medical Condition",
  "Sickle Cell Disease",
  "Skin Disease",
  "Speech Impairment",
  "Spina Bifida",
  "Spinal Cord Injury",
  "Spinal Deformity",
  "Stickler Syndrome",
  "Stroke",
  "Syringomyelia",
  "Tourette Syndrome",
  "Traumatic Brain Injury",
  "Treated for Life Threatening Cancer",
  "Tremors",
  "Tuberculosis",
  "Visual Disability",
  "Von Willebrand Disease",
  "Wheelchair User",
  "Williams Syndrome",
  "Witkott Aldrich Syndrome",
];

export const situations = [
  "Accepted into Ivy League School",
  "Accepted into Law School",
  "Accident Survivor",
  "Adopted",
  "Affected by Breast Cancer",
  "Affected by Cancer",
  "AP/IB Math and Science",
  "Artist-In-Residence Program",
  "Attend a High School that is Receiving Services from Tatum Music Company",
  "Attend a Public High School",
  "Attending a Judeo-Christian Affiliated Institution of Higher Learning",
  "Attending a Land-Grant University",
  "Attending an EAC/ABET-Accredited Program",
  "Breadwinner in Family",
  "Came to the United States before 16th Birthday",
  "Canadian Resident",
  "Caregiver",
  "Caring for Adult Relative",
  "Caring for Brain Injury Patient",
  "Caring for Elderly Relative",
  "Child of ALS Patient",
  "Child of a Parent of African-American Heritage",
  "Child of at least One Employed Parent",
  "Child of Blind Parent",
  "Child of Breast Cancer Patient",
  "Child of Convicted Felon",
  "Child of Deaf Parents",
  "Child of Deceased Parent",
  "Child of Deceased Public Servant",
  "Child of Disabled Parent",
  "Child of Divorced Parents",
  "Child of Farm Worker",
  "Child of First Responder",
  "Child of Immigrant",
  "Child of LGBTQ Parents",
  "Child of Migrant Worker",
  "Child of Parent with Cancer",
  "Child of Parent with Life-Threatening Disease",
  "Child of Single Parent",
  "Child of Widowed Parent",
  "Completed a Fire Cadet Program in Clark County",
  "Completed a Fire Cadet Program in Cowlitz County",
  "Completed a Fire Cadet Program in Skamania County",
  "Completed At Least Three Credit Hours in an ALA Accredited Master's Degree Program",
  "Convicted of Criminal Offense",
  "Currently Live in Actively Engaged in a UMOM Housing Program",
  "Current Ward of the Court",
  "Dependent Child",
  "Dependent of Injured Road Worker",
  "Displaced Homemaker",
  "Earned Credits Prior to High School Graduation",
  "Eligible for DACA",
  "Eligible for TPS",
  "Eligible Non-Citizen (As Defined By FAFSA)",
  "Employed",
  "Enrolled in an IEP or Section 504 Accommodation Plan",
  "Enrolled in a Summer Abroad Program",
  "Enrolled in a Summer School Program",
  "Enrolled in Dental School",
  "Enrolled in RN-to-BSN Program",
  "Family Member Diagnosed with Multiple Sclerosis",
  "Family Member Uses a Wheelchair",
  "Family Member with Bleeding Disorder",
  "First-Generation American",
  "First-Generation College Student",
  "Former Ward of the Court",
  "Foster Child",
  "Full-Time Student",
  "Gifted",
  "Grandparent",
  "Have an Active Lease and Live in a Balfour Beatty Community",
  "Have Not Defaulted on Any Financial Student Loans",
  "Homeless",
  "Hospital or Skilled Nursing Facility Employee",
  "Identify as LGBTQIA+ or Ally",
  "Immediate Family Member Has Had Cancer",
  "Immigrant",
  "Income 80% or Lower of HUD Area Median",
  "In Custody of the State",
  "Independent Child",
  "Independent Contractor",
  "Independent Student Status",
  "International Student",
  "Internship",
  "Involved in an UMOM Housing Program",
  "Live in a Habitat For Humanity Home",
  "Live in a Mobile or Manufactured Home",
  "Live in a Residential Facility",
  "Live in Government Housing",
  "Lost a Family Member",
  "Low-Income Household",
  "Married",
  "Middle-Income Household",
  "Migrant Worker",
  "Mother",
  "Multiple Birth Child",
  "Nontraditional / Returning Student",
  "On Break from College",
  "Online Student",
  "Orphan",
  "Orphaned Before 18th Birthday",
  "Overcame Adversity",
  "Parent",
  "Parent Injured in Accident",
  "Parent Receiving Social Security Disability Benefits",
  "Parent who is/was Incarcerated in any State Prison System",
  "Participate in Free and Reduced Price Lunch (FRPL) Program",
  "Participate in Head Start Program",
  "Part-Time Employee",
  "Part-Time Student",
  "Passed WASL Exam or Equivalent",
  "Paygrade Of E-6 Or Below",
  "Paying for Own Education",
  "Paying Out-of-State Tuition",
  "Pell Grant Eligible",
  "Raised by Grandparents or Extended Family",
  "Receive Individual Education Plan (IEP) Services",
  "Refugee",
  "Relocated in High School",
  "Research Student",
  "Resident of a Balfour Beatty Military Community",
  "Resident of an AHMA Community",
  "Resident of Privately Owned Federally Assisted Rental Housing",
  "Resident of Pubic Housing in Hawaii",
  "Salutatorian",
  "Section 8 Tenant",
  "Self-Employed",
  "Single Father",
  "Single Mother",
  "Single Parent",
  "Single Parent of a Child under the Age of 12",
  "Student Teacher",
  "Studying Abroad",
  "Studying Abroad in Japan",
  "Taken One Actuarial Exam",
  "Teaching Assistantship",
  "Teen Parent",
  "Transfer Student",
  "Triplet",
  "Twin",
  "Undocumented Immigrant",
  "Valedictorian",
  "Victim of Crime",
  "Victim of Domestic Violence",
  "Victim of Human Trafficking",
  "Widow",
  "Widower",
  "Woman Returning to the Workforce",
  "Working a Minimum of 10 Hours Per Week While Attending School",
  "Working Parent",
];

export const miscellaneous = [
  "Accepted into a Sanctioned International Study Program",
  "Agnostic",
  "All-Academic Team Honors",
  "Amateur Radio License",
  "Animal Care Experience",
  "Applicant/Parent Needs a Minimum of 2 Years Employment in Footwear Industry",
  "Atheist",
  "Attended Central Elementary School",
  "Attended Charlton Public K-8",
  "Attended Courtney Elementary School",
  "Attended Elm Park Community School",
  "Attended Faye Webb Elementary School",
  "Attended Hayward Middle School",
  "Attended Mary A White Elementary School",
  "Attended Possum Middle School",
  "Attended Reid Middle School",
  "Attended Seven Hills Charter Public School",
  "Attended Silver Star Elementary",
  "Attended the John Avery Parker School",
  "Attended Wheeling Middle School",
  "Bilingual",
  "Calhoun Intermediate School District",
  "Candidate to Complete Booker High School's Law Academy",
  "Certified Diver",
  "Challenge Scholar",
  "Child of Former Employee of a Maui Sugar Business",
  "Child of Midland County Sheriff's Office Retiree",
  "Child of Midland Fire Department Retiree",
  "Child of Midland Police Department Retiree",
  "Completed 100 Hours of Community or Leadership Service",
  "Completed Latin Studies In High School",
  "Completed Two Actuarial Exams",
  "Conscientious Objector",
  "Convicted of Criminal Offense",
  "Current Rent-a-Center Franchise Owner",
  "Demonstrate Academic Achievement and Motivation to Succeed in College",
  "Demonstrate a Commitment to Domestic Violence Prevention",
  "Demonstrate a Commitment to Improving the Quality of Life of Others",
  "Demonstrate Artistic Talent",
  "Demonstrate a Strong Christian Faith",
  "Demonstrate a Strong Work Ethic",
  "Demonstrate Character and Leadership Qualities",
  "Demonstrate Diamond in the Rough Qualities",
  "Demonstrate Good Character",
  "Demonstrate Good Character and Standing in the Community",
  "Demonstrate Leadership Abilities",
  "Demonstrate Leadership, Ambition, Achievement, and Good Academic Standing",
  "Demonstrate Leadership, Dependability, and Citizenship",
  "Demonstrate Optimism and Determination",
  "Demonstrates the Most Compassion in Caring and Treatment of Patients",
  "Demonstrate Strong Academic Achievement",
  "Demonstrate Strong Character",
  "Dependent of Bookstore Employee",
  "Dependent of City of Midland Retiree",
  "Dependent of Midland Fire Department Retiree",
  "Descendant of Littlestown Foundry, Inc. Retiree",
  "Dog Owner",
  "Eagle Scout",
  "Employed at an Asian Restaurant",
  "Employed at a Welding Distributorship",
  "English Is Second Language",
  "Established Radiologic Technician",
  "Exhibited in the Nueces County Junior Livestock Show, Texas",
  "Fluent in Spanish",
  "Former Employee of a Maui Sugar Business",
  "Former Employee of the Salina Country Club",
  "From a Developing Country",
  "General Class Radio License",
  "Grace Pacific Outstanding Keiki Scholars Program Participant",
  "Graduate of Saint Brendan School",
  "Graduate of Union Elementary School",
  "Humanist",
  'Identified as a "Turnaround" Student',
  "LGBTQ Advocate",
  "Live Near a Simon Mall or Surrounding Community",
  "May Not Qualify for Traditional Scholarships",
  "Mock Trial Participant",
  "Panhellenic Woman",
  "Participant in a Fire Cadet Program",
  "Participant in Friendly House Programs",
  "Participant in Programs at Worcester Youth Center",
  "Participant of Linworth Experiential Program",
  "Participate in Travel Abroad Program",
  "Passion for Headphones and Audio Content Creation",
  "Peanut Producer",
  "Pilot",
  "Pilot in Training",
  "Planning to Enter a Small Animal Practice after Graduation",
  "Plan to Participate in a Distinct Educational Opportunity Beyond the Typical School Setting",
  "Possess a Desire to Achieve",
  "Raised by Hobbits",
  "Recipient of the Columbia Vista Corporation Scholarship",
  "Recommended by an H. D. Segur Client",
  "Red Cross Volunteer",
  "Registered Libertarian",
  "Relative of Deceased or Disabled City of Worcester Firefighter",
  "Relative of Deceased or Disabled City of Worcester Police Officer",
  "Relative of Ohio County Sheriff's Office Retiree",
  "Relative of West Virginia State Patrol Retiree",
  "Relative of Wheeling Police Department Retiree",
  "Researching Building Codes",
  "Resident of Lincoln Village Apartments",
  "Resident of Westmoreland County Housing Authority Public Housing",
  "Resident of Westmoreland Non-Profit Housing Corporation",
  "Respect and Value Diversity",
  "Role in Potato Industry",
  "Stationed at Aberdeen Proving Ground",
  "Stationed at Edwards AFB",
  "Stationed at Eglin AFB",
  "Stationed at Eielson AFB",
  "Stationed at Fort Bragg",
  "Stationed at Fort Meade",
  "Stationed at Fort Polk",
  "Stationed at Fort Riley",
  "Stationed at Fort Rucker",
  "Stationed at Fort Sill",
  "Stationed at Hurlburt Field",
  "Stationed at McConnell AFB",
  "Stationed at Seymour Johnson AFB",
  "Taken a Calculus-Level Math Class",
  "Taken AP Calculus",
  "Taken At Least Five Math Courses",
  "Taken or Will Take a Defensive Driving Course",
  "Taking Music Lessons from a Teacher who is a Member of the Piano Teachers Association",
  "Tall Stature",
  "Theatre Experience at a Local Community Theatre",
  "Union Scholar",
];

export const afflitionEntities = [
  "100th Infantry Battalion Veterans",
  "101st Airborne Division Association",
  "10th Mountain Division Association",
  "11th Armored Cavalry Veterans of Vietnam and Cambodia",
  "2 + 2 Program",
  "25th Infantry Division Association",
  "37th Division Veterans Association",
  "43rd Infantry Division Veterans Association",
  "4-H",
  "531 Gray Ghost Squadron Association",
  "70th Infantry Division Association",
  "7th Infantry Regiment Association",
  "82nd Airborne Division Association",
  "95th Division Army Reserves",
  "A-7 Corsair Association",
  "AAA Tidewater Virginia",
  "AASP - The Palynological Society",
  "Abbott Health Care",
  "ABC Stores",
  "Aberdeen Proving Ground Community Spouses Club",
  "Abrazo Adoption Associates",
  "Acacia Fraternity",
  "Academic Library Association of Ohio",
  "Academic Pediatric Association",
  "Academy for Eating Disorders",
  "Academy of Accounting Historians",
  "Academy of Criminal Justice Sciences",
  "Academy of Dental Materials",
  "Academy of Management",
  "Academy of Medical-Surgical Nurses",
  "Academy of Model Aeronautics",
  "Academy of Neonatal Nursing",
  "Academy of Nutrition and Dietetics",
  "Academy of Osseointegration",
  "Acceptance Now",
  "Accounting and Financial Women's Alliance",
  "Accounting Society",
  "Acoustical Society of America",
  "Adams Fairacre Farms",
  "African American Youth Harvest Foundation",
  "African Community Center's Ambassador Program",
  "African Community Center's Refugee Leaders Program",
  "African Methodist Episcopal",
  "AfterCollege",
  "AGC Houston Member Firm",
  "Aggregate Producers of Wisconsin",
  "AgHeritage Farm Credit Services",
  "Agricultural and Applied Economics Association",
  "Agricultural Communicators of Tomorrow",
  "Agriculture Future of America",
  "Agriculture Teachers Association of Texas",
  "AHLA",
  "AHMA Member Community",
  "Air and Waste Management Association",
  "Aircraft Electronics Association",
  "Aircraft Owners and Pilots Association",
  "Air Force Association",
  "Air Force Clubs",
  "Air Force ROTC",
  "Air Force Sergeants Association",
  "Air Line Pilots Association",
  "Airport Minority Advisory Council",
  "Akins Eagle Band",
  "ALA American Association of School Librarians",
  "ALA Association for Library Collections and Technical Services",
  "ALA Association for Library Service to Children",
  "ALA Association for Library Trustees and Advocates",
  "ALA Association of College and Research Libraries",
  "ALA Association of College and Research Libraries, New England Chapter",
  "Alabama Association of Middle School Principals",
  "Alabama Association of Nursing Students",
  "Alabama Association of School Office Personnel",
  "Alabama Cattlemen's Association",
  "Alabama Conservation Enforcement Officer Association",
  "Alabama Education Association",
  "Alabama Farmers Federation",
  "Alabama Golf Course Superintendents Association",
  "Alabama Grocers Association",
  "Alabama High School Athletic Association",
  "Alabama Horse Council",
  "Alabama League for Nursing",
  "Alabama Library Association",
  "Alabama Public Health Association",
  "Alabama School Library Association",
  "Alabama State Nurses Association",
  "Alabama Tire Dealers Association",
  "Alabama Water Environment Association",
  "ALA Black Caucus",
  "ALA Government Documents Round Table",
  "ALA Library Administration and Management Association",
  "ALA Map and Spatial Information Round Table",
  "Alamo Drafthouse Cinema",
  "ALA New Members Round Table",
  "ALA Public Library Association",
  "ALA Reference and User Services Association",
  "Alaska Academy of Physician Assistants",
  "Alaska Forest Association",
  "Alaska National Guard Enlisted Association",
  "Alaska Native Brotherhood/Sisterhood",
  "Alaska Nurses Association",
  "Alaska Professional Nurses Organization",
  "Alaska Public Health Association",
  "Alaska State Firefighters Association",
  "ALA Young Adult Library Services Association",
  "Alberta Association of Library Technicians",
  "Albuquerque Youth Symphony Program",
  "Alegacy Group",
  "Alexander & Baldwin",
  "Alexander Graham Bell Association for the Deaf",
  "All Dressage Association",
  "Alliance of Hazardous Materials Professionals",
  "Alliant Energy",
  "All Saints Evangelical Lutheran Church",
  "Alpha Chi Rho",
  "Alpha Delta Pi",
  "Alpha Gamma Rho",
  "Alpha Lambda Chapter of Theta Chi",
  "Amalgamated Transit Union",
  "Amarillo Bowling Association",
  "Amarillo Women's Bowling Association",
  "Amarillo Young American Bowling Association",
  "Americal Division Veterans Association",
  "American Academy of Advertising",
  "American Academy of Allergy, Asthma, & Immunology",
  "American Academy of Ambulatory Care Nursing",
  "American Academy of Child and Adolescent Psychiatry",
  "American Academy of Facial Plastic and Reconstructive Surgery",
  "American Academy of Family Physicians",
  "American Academy of Forensic Sciences",
  "American Academy of Medical Administrators",
  "American Academy of Neurology",
  "American Academy of Neuroscience Nurses",
  "American Academy of Nursing",
  "American Academy of Optometry",
  "American Academy of Oral and Maxillofacial Radiology",
  "American Academy of Orthopaedic Surgeons",
  "American Academy of Pediatric Dentistry",
  "American Academy of Pediatrics",
  "American Academy of Periodontology",
  "American Academy of Physicians Assistants",
  "American Academy of Religion",
  "American Academy of Sleep Medicine",
  "American Academy of Students of Pharmacy",
  "American Academy of Underwater Sciences",
  "American Accounting Association",
  "American Advertising Federation",
  "American Advertising Federation-Greater Evansville",
  "American Alpine Club",
  "American Angus Association",
  "American Anthropological Association",
  "American Art Therapy Association",
  "American Assembly for Men in Nursing",
  "American Association for Applied Linguistics",
  "American Association for Cancer Research",
  "American Association for Clinical Chemistry",
  "American Association for Dental Research",
  "American Association for Geodetic Surveying",
  "American Association for Geriatric Psychiatry",
  "American Association for Hand Surgery",
  "American Association for Justice",
  "American Association for Laboratory Animal Science",
  "American Association for Marriage and Family Therapy",
  "American Association for Nude Recreation",
  "American Association for Respiratory Care",
  "American Association for the History of Nursing",
  "American Association for the Study of Liver Diseases",
  "American Association of Airport Executives",
  "American Association of Anatomists",
  "American Association of Avian Pathologists",
  "American Association of Bioanalysts",
  "American Association of Bovine Practitioners",
  "American Association of Colleges of Pharmacy",
  "American Association of Critical-Care Nurses",
  "American Association of Diabetes Educators",
  "American Association of Drilling Engineers",
  "American Association of Endodontists",
  "American Association of Equine Practitioners",
  "American Association of Family and Consumer Sciences",
  "American Association of Immunologists",
  "American Association of Law Libraries",
  "American Association of Museums",
  "American Association of Neurological Surgeons",
  "American Association of Neuromuscular and Electrodiagnostic Medicine",
  "American Association of Neuroscience Nurses",
  "American Association of Nurse Anesthetists",
  "American Association of Nurse Practitioners",
  "American Association of Occupational Health Nurses",
  "American Association of Pediatric Plastic Surgeons",
  "American Association of People with Disabilities",
  "American Association of Petroleum Geologists",
  "American Association of Physicians of Indian Origin",
  "American Association of Physicists in Medicine",
  "American Association of Physics Teachers",
  "American Association of Plastic Surgeons",
  "American Association of Public Health Dentistry",
  "American Association of Respiratory Care",
  "American Association of School Administrators",
  "American Association of Small Ruminant Practitioners",
  "American Association of State Troopers",
  "American Association of Surgical Physician Assistants",
  "American Association of Swine Veterinarians",
  "American Association of Teachers of French",
  "American Association of Teachers of Japanese",
  "American Association of Teachers of Spanish and Portuguese",
  "American Association of Textile Chemists and Colorists",
  "American Association of University Women",
  "American Association of Women Dentists",
  "American Association of Woodturners",
  "American Astronomical Society",
  "American Baptist Church",
  "American Bar Association",
  "American Burn Association",
  "American Bus Association",
  "American Business Women's Association",
  "American Center for Mongolian Studies",
  "American Ceramics Society",
  "American Chemical Society",
  "American Classical League",
  "American College of Chest Physicians",
  "American College of Clinical Pharmacy",
  "American College of Healthcare Executives",
  "American College of Medical Practice Executives",
  "American College of Neuropsychopharmacology",
  "American College of Nurse-Midwives",
  "American College of Nurse Practitioners",
  "American College of Obstetricians and Gynecologists",
  "American College of Osteopathic Family Physicians",
  "American College of Prosthodontists",
  "American College of Rheumatology",
  "American College of Sports Medicine",
  "American College of Surgeons",
  "American Composites Manufacturers Association",
  "American Concrete Institute",
  "American Concrete Pavement Association",
  "American Congress of Rehabilitation Medicine",
  "American Constitution Society for Law and Policy",
  "American Contract Bridge League",
  "American Correctional Food Service Association",
  "American Council for Polish Culture",
  "American Council of Academic Plastic Surgeons",
  "American Council of Engineering Companies",
  "American Council of the Blind",
  "American Council on the Teaching of Foreign Languages",
  "American Criminal Justice Association",
  "American Culinary Federation",
  "American Dairy Goat Association",
  "American Dairy Science Association",
  "American Darts Organization",
  "American Daylily Society",
  "American Dental Assistants Association",
  "American Dental Association",
  "American Dental Education Association",
  "American Dental Hygienists Association",
  "American Diabetes Association",
  "American Educational Research Association",
  "American Education Finance Association",
  "American Epilepsy Society",
  "American Farm Bureau Federation",
  "American Farmers & Ranchers",
  "American Federation for Medical Research",
  "American Federation of Government Employees",
  "American Federation of School Administrators",
  "American Federation of State, County and Municipal Employees",
  "American Federation of Teachers",
  "American Fisheries Society",
  "American Flint Glass Workers Union",
  "American Folklore Society",
  "American Foreign Service Association",
  "American Foundry Society",
  "American Gastroenterological Association",
  "American Geological Institute",
  "American Geophysical Union",
  "American Geriatrics Society",
  "American GI Forum",
  "American Goat Association",
  "American Goat Federation",
  "American Guernsey Association",
  "American Guild of Musical Artists",
  "American Guild of Organists",
  "American Head and Neck Society",
  "American Health Information Management Association",
  "American Heart Association",
  "American Hellenic Educational Progressive Association",
  "American Hellenic Professional Society",
  "American Hereford Association",
  "American Historical Association",
  "American Holistic Nurses' Association",
  "American Horticultural Therapy Association",
  "American Indian and Alaska Native Employee Association",
  "American Indian Library Association",
  "American Indian Science and Engineering Society",
  "American Inns of Court",
  "American Institute for Conservation",
  "American Institute of Aeronautics and Astronautics",
  "American Institute of Afghanistan Studies",
  "American Institute of Architects",
  "American Institute of Bangladesh Studies",
  "American Institute of Certified Public Accountants",
  "American Institute of Chemical Engineers",
  "American Institute of Fishing Research Biologists",
  "American Institute of Maghrib Studies",
  "American Institute of Mining, Metallurgical, and Petroleum Engineers",
  "American Institute of Physics",
  "American Institute of Professional Geologists",
  "American Institute of Steel Construction",
  "American Institute of Wine & Food",
  "American Jersey Cattle Association",
  "American Journalism Historians Association",
  "American Junior Brahman Association",
  "American Junior Paint Horse Association",
  "American Kennel Club",
  "American Kinesiotherapy Association",
  "American Legion",
  "American Legion Auxiliary",
  "American Legion Boys State Program",
  "American Legion District 6",
  "American Legion Girls State Program",
  "American Legion Junior Auxiliary",
  "American Legion Post 9",
  "American Legion Sports Team",
  "American Library Association",
  "American Maine-Anjou Association",
  "American Malacological Society",
  "American Marketing Association",
  "American Mathematical Association of Two-Year Colleges",
  "American Mathematical Society",
  "American Medical Association",
  "American Medical Informatics Association",
  "American Medical Student Association",
  "American Medical Technologists",
  "American Medical Women's Association",
  "American Mensa",
  "American Meteorological Society",
  "American Military Retirees Association",
  "American Mining Rights Association",
  "American Mold Builders Association",
  "American Montessori Society",
  "American Morgan Horse Association",
  "American Mothers",
  "American Moving and Storage Association",
  "American Musicological Society",
  "American Mutual Life Association",
  "American Nephrology Nurses' Association",
  "American Neurotology Society",
  "American Nuclear Society",
  "American Nurses Association",
  "American Nursing Informatics Association",
  "American Nystagmus Network",
  "American Occupational Therapy Association",
  "American Oil Chemists' Society",
  "American Optometric Student Association",
  "American Orff-Schulwerk Association",
  "American Organization of Nurse Executives",
  "American Ornithological Society",
  "American Orthopaedic Foot and Ankle Society",
  "American Osteopathic Association",
  "American Paint Horse Association",
  "American Peptide Society",
  "American Petroleum Institute",
  "American Pharmaceutical Association",
  "American Philosophical Association",
  "American Physical Society",
  "American Physical Therapy Association",
  "American Physiological Society",
  "American Phytopathological Society",
  "American Planning Association",
  "American Podiatric Medical Association",
  "American Pointer Club",
  "American Political Science Association",
  "American Postal Workers Union",
  "American Psychiatric Association",
  "American Psychiatric Nurses Association",
  "American Psychological Association",
  "American Public Health Association",
  "American Public Works Association",
  "American Quarter Horse Association",
  "American Quarter Horse Youth Association",
  "American Rabbit Breeders Association",
  "American Radio Relay League",
  "American Railway Engineering and Maintenance-of-Way Association",
  "American Rambouillet Sheep Breeders Association",
  "American Red Cross",
  "American Romanian Orthodox Youth",
  "American Saddlebred Association of Wisconsin",
  "American Saddlebred Horse Association",
  "American Saddlebred Horse Association of Alabama",
  "American Saddlebred Horse Association of Georgia",
  "American Saddlebred Horse Association of Virginia",
  "American School Counselor Association",
  "American School Health Association",
  "American School of Classical Studies at Athens",
  "American Schools of Oriental Research",
  "American Shoulder and Elbow Surgeons",
  "American Society for Biochemistry and Molecular Biology",
  "American Society for Bone and Mineral Research",
  "American Society for Cell Biology",
  "American Society for Clinical Investigation",
  "American Society for Clinical Laboratory Science",
  "American Society for Clinical Pathology",
  "American Society for Clinical Pharmacology and Therapeutics",
  "American Society for Dermatologic Surgery",
  "American Society for Eighteenth-Century Studies",
  "American Society for Engineering Education",
  "American Society for Enology and Viticulture",
  "American Society for Environmental History",
  "American Society for Gastrointestinal Endoscopy",
  "American Society for Healthcare Environmental Services",
  "American Society for Healthcare Food Service Administrators",
  "American Society for Healthcare Risk Management",
  "American Society for Hispanic Art Historical Studies",
  "American Society for Horticultural Science",
  "American Society for Industrial Security",
  "American Society for Information Science and Technology",
  "American Society for Investigative Pathology",
  "American Society for Legal History",
  "American Society for Mass Spectrometry",
  "American Society for Microbiology",
  "American Society for Nutrition",
  "American Society for Pain Management Nursing",
  "American Society for Parenteral and Enteral Nutrition",
  "American Society for Peripheral Nerve",
  "American Society for Pharmacology and Experimental Therapeutics",
  "American Society for Photobiology",
  "American Society for Photogrammetry and Remote Sensing",
  "American Society for Public Administration",
  "American Society for Quality",
  "American Society for Reconstructive Microsurgery",
  "American Society for Surgery of the Hand",
  "American Society for Theatre Research",
  "American Society of Agricultural Engineers",
  "American Society of Agronomy",
  "American Society of Anesthesiologists",
  "American Society of Certified Engineering Technicians",
  "American Society of Church History",
  "American Society of Civil Engineers",
  "American Society of Clinical Oncology",
  "American Society of Colon and Rectal Surgeons",
  "American Society of Composers, Authors and Publishers",
  "American Society of Cytopathy",
  "American Society of Electroneurodiagnostic Technologists",
  "American Society of Engineers of Indian Origin",
  "American Society of Extracorporeal Technology",
  "American Society of Hand Therapists",
  "American Society of Health-System Pharmacists",
  "American Society of Heating, Refrigerating and Air-Conditioning Engineers",
  "American Society of Hematology",
  "American Society of Human Genetics",
  "American Society of Ichthyologists and Herpetologists",
  "American Society of Interior Designers",
  "American Society of Journalists and Authors",
  "American Society of Landscape Architects",
  "American Society of Limnology and Oceanography",
  "American Society of Mammalogists",
  "American Society of Maxillofacial Surgeons",
  "American Society of Mechanical Engineers",
  "American Society of Military Comptrollers",
  "American Society of Naturalists",
  "American Society of Naval Engineers",
  "American Society of Nephrology",
  "American Society of Ophthalmic Registered Nurses",
  "American Society of PeriAnesthesia Nurses",
  "American Society of Pharmacognosy",
  "American Society of Plant Taxonomists",
  "American Society of Plastic Surgeons",
  "American Society of Plumbing Engineers",
  "American Society of Primatologists",
  "American Society of Professional Estimators",
  "American Society of Radiologic Technologists",
  "American Society of Safety Professionals",
  "American Society of Sugar Cane Technologists",
  "American Society of Training and Development",
  "American Society of Transplantation",
  "American Society of Transplant Surgeons",
  "American Society of Travel Agents",
  "American Society of Tropical Medicine and Hygiene",
  "American Sociological Association",
  "American Soybean Association",
  "American Speech-Language-Hearing Association",
  "American Statistical Association",
  "American String Teachers Association",
  "American Studies Association",
  "American Subcontractors' Association",
  "American Subcontractors Association, San Antonio Chapter",
  "American Syringomyelia & Chiari Alliance Project",
  "American Taxation Association",
  "American Theological Library Association",
  "American Therapeutic Recreation Association",
  "American Translators Association",
  "American Truck Historical Society",
  "American Urological Association",
  "American Veterinary Medical Association",
  "American Water Resources Association",
  "American Water Works Association",
  "American Welding Society",
  "American Woman's Society of Certified Public Accountants",
  "American Women in Radio and Television",
  "AMIKids Southwest Florida",
  "AMTSociety",
  "AMVETS Auxiliary",
  "AmWINS Group",
  "Anadarko Petroleum Corporation",
  "Anchor Club",
  "Ancient Order United Workers",
  "Animal Behavior Society",
  "Animal Legal Defense Fund",
  "Antique Caterpillar Machinery Owners Club",
  "Any Orthodox Church in West Virginia",
  "Appaloosa Horse Club",
  "Appaloosa Youth Association",
  "Apple Hill Growers Association",
  "Appraisal Institute",
  "Arab American Association of Engineers & Architects",
  "Arabian Horse Association",
  "Arabian Horse Association of Southern California",
  "Arcadia High School",
  "Archaeological Institute of America",
  "AriensCo",
  "Arizona Association of Latino Administrators and Superintendents",
  "Arizona Association of Law Libraries",
  "Arizona Athletic Trainers' Association",
  "Arizona Business Education Association",
  "Arizona Education Association",
  "Arizona Elk Society",
  "Arizona Farm Bureau Federation",
  "Arizona Food Marketing Alliance",
  "Arizona Hispanic Chamber of Commerce",
  "Arizona Hunter Jumper Association",
  "Arizona Landscape Contractors' Association",
  "Arizona Library Association",
  "Arizona Multihousing Association",
  "Arizona New Mexico Telecommunications Association",
  "Arizona Nurses Association",
  "Arizona Occupational Therapy Association",
  "Arizona Public Health Association",
  "Arizona Quarter Racing Association",
  "Arizona School Counselors Association",
  "Arkansas Association of Educational Administrators",
  "Arkansas Association of School Business Officials",
  "Arkansas Association of Special Education Administrators",
  "Arkansas Cattlemen's Association",
  "Arkansas Council for Exceptional Children",
  "Arkansas Education Association",
  "Arkansas Farm Bureau",
  "Arkansas Junior Angus Association",
  "Arkansas Junior Cattlemen's Association",
  "Arkansas Nurses Association",
  "Arkansas Ready Mixed Concrete Association",
  "Arkansas Recreation and Parks Association",
  "Arkansas School Nutrition Association",
  "Arkansas Vocational Agriculture Teachers Association",
  "Arkansas Water and Wastewater Managers Association",
  "Arkansas Women in Agriculture",
  "Arleigh Burke Association",
  "Arlington Local High School",
  "ARMA International",
  "Armed Forces Benefit Association",
  "Armed Forces Communications and Electronics Association",
  "Armenian Church of America",
  "Army and Air Force Exchange Service",
  "Army Aviation Association of America",
  "Army Engineer Association",
  "Army Engineer Spouses Club",
  "Army ROTC",
  "Army Spouses' Club of the Greater Washington Area",
  "Arnold Air Society",
  "Art Libraries Society of North America",
  "Ascend: Pan-Asian Leaders in Finance and Accounting",
  "Asian American Architects/Engineers Association",
  "Asian American Bar Association of Kansas City",
  "Asian American Journalists Association",
  "Asian American/Pacific Islander Nurses Association",
  "Asian American Psychological Association",
  "Asian American Real Estate Association",
  "Asian Pacific Alumni Association",
  "Asian/Pacific American Council of Georgia",
  "Asian Pacific Americans Librarians Association",
  "Asian Pacific State Employees Association",
  "ASM International",
  "ASMO Manufacturing",
  "Asphalt Contractors Association of Florida",
  "Asphalt Pavement Association of California",
  "ASPIRA",
  "Associated Builders and Contractors",
  "Associated Builders and Contractors South Texas Chapter",
  "Associated General Contractors",
  "Associated General Contractors of Houston",
  "Associated General Contractors Student Chapter",
  "Associated Landscape Contractors of America",
  "Associates of the American Foreign Service Worldwide",
  "Associates of Vietnam Veterans of America",
  "Association for Academic Health Sciences Libraries",
  "Association for Asian Studies",
  "Association for Canadian Studies",
  "Association for Chemoreception Sciences",
  "Association for Computing Machinery",
  "Association for Educational Communications and Technology",
  "Association for Education and Rehabilitation of the Blind and Visually Impaired",
  "Association for Education in Journalism and Mass Communication",
  "Association for Facilities Engineering",
  "Association for Financial Professionals",
  "Association for Glycogen Storage Disease",
  "Association for Healthcare Foodservice",
  "Association for Indiana Media Educators",
  "Association for Information Technology Professionals",
  "Association for Iron and Steel Technology",
  "Association for Iron and Steel Technology Southeastern Chapter",
  "Association for Jewish Studies",
  "Association for Library and Information Science Education",
  "Association for Molecular Pathology",
  "Association for Non-Traditional Students in Higher Education",
  "Association for Professionals in Infection Control and Epidemiology",
  "Association for Radiologic and Imaging Nursing",
  "Association for Research in Vision and Ophthalmology",
  "Association for Research on Nonprofit Organizations and Voluntary Action",
  "Association for Surgical Education",
  "Association for the Advancement of Baltic Studies",
  "Association for the Advancement of Medical Instrumentation",
  "Association for Theatre in Higher Education",
  "Association for the Sociology of Religion",
  "Association for the Study of the Middle East and Africa",
  "Association for Women in Aviation Maintenance",
  "Association for Women in Communications",
  "Association for Women in Science",
  "Association for Women in Sports",
  "Association of American Geographers",
  "Association of Aviation Ordnancemen",
  "Association of Biomolecular Resource Facilities",
  "Association of Black Cardiologists",
  "Association of California Nurse Leaders",
  "Association of California School Administrators",
  "Association of California State Supervisors",
  "Association of Camp Nurses",
  "Association of Certified Fraud Examiners",
  "Association of College Unions International",
  "Association of Energy Engineers",
  "Association of Energy Services Companies",
  "Association of Engineering Geologists",
  "Association of Family Practice Physicians",
  "Association of Field Ornithologists",
  "Association of Fire Districts of the State of New York",
  "Association of Flight Attendants",
  "Association of Former Intelligence Officers",
  "Association of Government Accountants",
  "Association of Graduates",
  "Association of Illinois School Library Educators",
  "Association of Indians in America",
  "Association of Insurance Compliance Professionals",
  "Association of Jewish Libraries",
  "Association of Jewish Libraries of Southern California",
  "Association of Latino Administrators and Superintendents",
  "Association of Latino Professionals in Finance and Accounting",
  "Association of Law Libraries of Upstate New York",
  "Association of Literary Scholars, Critics, and Writers",
  "Association of Lithuanian Workers",
  "Association of Montana Troopers",
  "Association of Moving Image Archivists",
  "Association of Nurses in AIDS Care",
  "Association of Old Crows",
  "Association of Pediatric Hematology/Oncology Nurses",
  "Association of Perioperative Registered Nurses",
  "Association of Physician Assistants in Cardiovascular Surgery",
  "Association of Program Directors in Radiology",
  "Association of Railroad Advertising and Marketing",
  "Association of Rehabilitation Nurses",
  "Association of Rheumatology Health Professionals",
  "Association of School Business Officials Illinois",
  "Association of Southeastern Biologists",
  "Association of Surgical Assistants",
  "Association of Surgical Technologists",
  "Association of Tennis Professionals",
  "Association of Theatrical Press Agents and Managers",
  "Association of the Sons of Poland",
  "Association of the United States Army",
  "Association of the United States Navy",
  "Association of the Wall and Ceiling Industry",
  "Association of University Radiologists",
  "Association of University Technology Managers",
  "Association of Women Psychiatrists",
  "Association of Women's Health, Obstetric and Neonatal Nurses",
  "Association of Women Surgeons",
  "Assured Life Association",
  "ASTA",
  "Asthma Allergy Center",
  "Astronomical League",
  "Athletic Trainers of Massachusetts",
  "Athletic Trainers Society of New Jersey",
  "Atlanta Association of Black Journalists",
  "Atlanta Law Libraries Association",
  "Atlantic Provinces Library Association",
  "Audio Engineering Society",
  "Australian Federation of Graduate Women",
  "Autism Society of America",
  "Automotive Aftermarket Association of the Carolinas and Tennessee",
  "Automotive Aftermarket Association Southeast",
  "Automotive Parts Associates",
  "Automotive Recyclers Association",
  "Auto Value",
  "Auxiliary to the Sons of Union Veterans of the Civil War",
  "Aviation Boatswain Mates Association",
  "AVS-Science and Technology of Materials, Interfaces, and Processing",
  "Ayrshire Breeders' Association",
  "Bahá'í Faith",
  "Bakery, Confectionery, Tobacco Workers and Grain Millers International Union",
  "Bank of America",
  "Bank of Hawaii Corporation",
  "Baptist",
  "Baptist Church",
  "Baptist General Convention of Texas",
  "Baptist Life",
  "Barometric Nurses Association",
  "Bartlett Cocke General Contractors",
  "BASF African American Employees Resource Group",
  "Battelle Memorial Institute",
  "Battle Creek Central High School",
  "Battle Creek Central High School Class of 1949",
  "Battle Creek Central High School Class of 1951",
  "Beckley United Methodist Temple",
  "Bedding Plants International",
  "Beefmaster Breeders United",
  "Beldon Enterprises",
  "Bella Collina Towne and Golf Club",
  "Best Friends",
  "Beta Sigma Phi",
  "Beta Theta Pi",
  "Bethel AME Church",
  "BetterLife",
  "Bibb Sheriff's Office",
  "Big Brothers Big Sisters",
  "Big Brothers Big Sisters of Cedar Rapids & East Central Iowa",
  "Biomedical Club",
  "Biomedical Engineering Society",
  "Biophysical Society",
  "Black Data Processing Associates",
  "Black Hills Angus Association",
  "Black Hills Home Builders Association",
  "Blackhorse Association",
  "Blacks in Government",
  "Bleeding Disorders Association of Northeast New York",
  "Blinded Veterans Association",
  "Blue Bird Auxiliary",
  "BNY Mellon",
  "Bodycote Grand Rapids Plant",
  "Bodycote Holland Plant",
  "Bonita Springs Area Chamber of Commerce",
  "Boone County Fire Department",
  "Border Regional Library Association",
  "Border States Electric",
  "Botanical Society of America",
  "Boulder Amateur Radio Club",
  "Boule Education Initiative",
  "Bowie Varsity Basketball Team",
  "Bowie Varsity Football Team",
  "Boy Scouts: Eagle Scouts",
  "Boy Scouts: Explorer Scouts",
  "Boy Scouts of America",
  "Boy Scouts of America, Great Smoky Mountain Council",
  "Boys & Girls Club",
  "Boys & Girls Club of Bristol",
  "Boys & Girls Club of Columbus",
  "Boys & Girls Clubs of Southwest Washington",
  "Boys & Girls Clubs of Western Pennsylvania",
  "Briar Club",
  "Bricklayers & Allied Craftworkers Local 3 CA",
  "British Columbia Library Association",
  "British Federation of Women Graduates",
  "Broadcast Cable Financial Management Association",
  "Broadcast Education Association",
  "Brookside Golf & Country Club",
  "Brotherhood of Locomotive Engineers",
  "Brotherhood of St. Anthony Mutual Benefit of the State of California",
  "Brown Swiss Association of the U.S.A.",
  "Buckeye Teachers Association",
  "Buddhist",
  "Builders Exchange of Santa Clara County",
  "Building Contractors Association of the Wood River Valley",
  "Bulkeley High School",
  "Bulkeley High School Alumni",
  "Bumper to Bumper",
  "Buon Tempo Club",
  "Bureau of Wholesale Sales Representatives",
  "Burger King",
  "Business and Professional Women's Association",
  "Business Education Association of Maine",
  "Business Professionals of America",
  "Business Teachers Association of New York State",
  "Business Technology Association",
  "Business Women of Missouri",
  "Byrd Prillerman School, West Virginia",
  "Cactus and Pine Golf Course Superintendents Association",
  "Cactus Feeders",
  "Calhoun County Chapter of the Michigan Association of Retired School Personnel",
  "California Academic and Research Libraries",
  "California Academy of Physician Assistants",
  "California Agricultural Irrigation Association",
  "California Association for Health, Physical Education, Recreation and Dance",
  "California Association of Educational Office Professionals",
  "California Association of Highway Patrolmen",
  "California Association of Latino Superintendents and Administrators",
  "California Botanical Society",
  "California Broadcasters Association",
  "California Career Development Association",
  "California Cattlemen's Association",
  "California Citrus Mutual",
  "California Communications Association",
  "California Correctional Peace Officers Association",
  "California Deer Association",
  "California Farm Bureau Federation",
  "California Grocers Association",
  "California Groundwater Association",
  "California High School Rodeo Association",
  "California Hotel & Lodging Association",
  "California Independent Oil Marketers Association",
  "California Interscholastic Federation",
  "California Junior Angus Association",
  "California Land Surveyors Association",
  "California Lawyers Association",
  "California League of Food Processors",
  "California Library Association",
  "California Lichen Society",
  "California Mathematics Council",
  "California Narcotic Officers' Association",
  "California Nurses Association",
  "California Nursing Students' Association",
  "California Paint Horse Association",
  "California Park and Recreation Society",
  "California Pork Producers Association",
  "California Professional Horsemen's Association",
  "California Scholarship Federation",
  "California School Employees Association",
  "California School Library Association",
  "California School Nurses Organization",
  "California School Nutrition Association",
  "California Society of Certified Public Accountants",
  "California State Employees Association",
  "California State Firefighters' Association",
  "California State Horsemen's Association",
  "California State University Employees Union",
  "California Strawberry Commission",
  "California Strawberry Commission Farm Worker",
  "California Strawberry Farm",
  "California Teachers Association",
  "California Women for Agriculture",
  "California Women in Timber",
  "California Women Lawyers",
  "Calista Corporation",
  "Camcorp Entities",
  "Camden",
  "Cameron Community Ministries",
  "Camillo Properties",
  "Camp Fire USA",
  "Canada Company",
  "Canadian Association for the History of Nursing",
  "Canadian Association of Law Libraries",
  "Canadian Association of Physics",
  "Canadian Federation of University Women",
  "Canadian Health Libraries Association",
  "Canadian Home Economics Association",
  "Canadian Library Association",
  "Canadian Nurses Foundation",
  "Canadian Orthopaedic Association",
  "Canadian Orthopaedic Research Society",
  "Capital Consultants Management Corporation",
  "Capital University Circle K Club",
  "Carlisle Barracks Spouses' Club",
  "Carolinas Associated General Contractors of America",
  "Carolinas Food Industry Council",
  "Carter-Lee Lumber",
  "Cartography and Geographic Information Society",
  "Carts and Parts",
  "Casa de Mañana",
  "Casey Equipment Corporation",
  "Castle and Cooke Hawaii",
  "Casualty Actuarial Society",
  "Casualty Actuarial Society Student Central",
  "Catholic Association of Foresters",
  "Catholic Biblical Association of America",
  "Catholic Church",
  "Catholic Daughters of the Americas",
  "Catholic Financial Life",
  "Catholic Kolping Society of America",
  "Catholic Ladies of Columbia",
  "Catholic Library Association",
  "Catholic Life Insurance",
  "Catholic Order of Foresters",
  "Catholic Parish in the Diocese of Saginaw, Michigan",
  "Catholic Union of Texas",
  "Catholic United Financial",
  "Catholic Workman",
  "CEDARS",
  "Centenary United Methodist Church",
  "Central Association of Obstetrics and Gynecology",
  "Central Carolina Black Nurses' Council",
  "Central Coast Greenhouse Growers Association",
  "Central European History Society",
  "Central Illinois Golf Course Superintendents Association",
  "Central Ohio Elite Soccer Club",
  "Central Pacific Bank",
  "Central Texas Electric Cooperative",
  "Cereal & Grains Association",
  "Cervical Spine Research Society",
  "Chaldean",
  "Challenge Scholars",
  "Chapel Hill United Methodist Church",
  "Charcot-Marie-Tooth International",
  "Charles Houston Bar Association",
  "Charlotte County Sheriff's Office",
  "Chartered Property Casualty Underwriters Society",
  "Chattooga Club",
  "Chelan County Fire District 1 Volunteer Association",
  "Chemical Society of Washington",
  "Chemung Canal Trust Company",
  "Chemung County 4-H Club",
  "Cherry Valley Fire Protection District",
  "Chesaning Nursing Care Center",
  "Chicago Association of Law Libraries",
  "Chicago Dietetic Association",
  "Chicago Herpetological Society",
  "Children of the Confederacy",
  "Children's Literature Association",
  "Chinese American Association of Minnesota",
  "Chinese American Citizens Alliance",
  "Chinese American Doctors Association of Houston",
  "Chinese American Librarians Association",
  "Chinese Language Teachers Association",
  "Chinese Professional Club of Houston",
  "Chiropractic Association of Louisiana",
  "Christ Church",
  "Christ Community Church in Saginaw County, Michigan",
  "Christian Brethren",
  "Christian Chiropractors Association",
  "Christian Church",
  "Christian Faith",
  "Christian Fellowship of Art Music Composers",
  "Christian Home Educators Association of California",
  "Christianity",
  "Christian Medical and Dental Association",
  "Christian Science",
  "Christie & Thomson",
  "Christmas Tree Farmers Association of New York",
  "Christ Memorial Baptist Church",
  "Church of Brethren",
  "Church of Christ",
  "Church of Francis de Sales, Mathews County, Virginia",
  "Church of God",
  "Church of the Visitation in Middlesex County, Virginia",
  "Circle K International",
  "City Barbeque",
  "City-Community Hospital School of Nursing",
  "City of Amarillo",
  "City of Amarillo Fire Department",
  "City of Beckley",
  "City of Midland",
  "City of Midland Fire Department",
  "City of Midland Police Department",
  "City of Pittsburgh",
  "City of Richmond Police Department",
  "City of Tyler Police Department",
  "City of Worcester Fire Department",
  "City of Worcester Police Department",
  "Civil Air Patrol",
  "Civil Air Patrol - West Virginia Wing",
  "Civitan International",
  "Clan Scott Society",
  "Clark County Cattlemen's Association",
  "Classical Association of New England",
  "Classical Association of the Atlantic States",
  "Classical Association of the Empire State",
  "Classical Association of the Middle West and South",
  "Clay Minerals Society",
  "Clinical Laboratories of Hawaii",
  "Club Managers Association of America",
  "Clubs",
  "Coalition of Black Trade Unionists",
  "Coast Guard Enlisted Association",
  "Coast Guard Mutual Assistance",
  "Coldwell Banker D'Ann Harper Realtors",
  "College Art Association",
  "College of American Pathologists",
  "College of Healthcare Information Management Executives",
  "Collier County Sheriff's Office",
  "Colorado American Saddlebred Horse Association",
  "Colorado Association of Fairs and Shows",
  "Colorado Association of Law Librarians",
  "Colorado Association of Public Employees",
  "Colorado Association of Stormwater and Floodplain Managers",
  "Colorado Cattlemen's Association/Junior Colorado Cattlemen's Association",
  "Colorado Congress of Foreign Language Teachers",
  "Colorado Education Association",
  "Colorado Environmental Health Association",
  "Colorado Government Finance Officers Association",
  "Colorado Motor Carriers Association",
  "Colorado Native Plant Society",
  "Colorado Nurses Association",
  "Colorado Oil and Gas Association",
  "Colorado Parks and Recreation Association",
  "Colorado Professional Fire Fighters",
  "Colorado Society of Certified Public Accountants",
  "Colorado State High School Rodeo Association",
  "Colorado Student Media Association",
  "Colorado Trappers and Predator Hunters Association",
  "Colorado Valley Independent Cattlemen's Association",
  "Colorado Weed Management Association",
  "Columbian Squires",
  "Columbus Country Club",
  "Columbus Division of Fire",
  "Columbus Education Association",
  "Combat Control Association",
  "Commissioned Officers' Association",
  "Commissioned Officers Association of the U.S. Public Health Service",
  "Communications Workers of America",
  "Community Bankers Association of Illinois",
  "Community Bankers of Iowa",
  "Community Church",
  "Computer-Using Educators",
  "Concordia Mutual Life Association",
  "Concrete Reinforcing Steel Institute",
  "Conference of Minority Transportation Officials",
  "Conference on Latin American History",
  "Congregational",
  "Congress of Neurological Surgeons",
  "Congress of Russian Americans",
  "Connecticut Advanced Practice Registered Nurses Society",
  "Connecticut Army National Guard",
  "Connecticut Association for Health, Physical Education, Recreation, and Dance",
  "Connecticut Association of Golf Superintendents",
  "Connecticut Association of School Librarians",
  "Connecticut Association of Therapeutic Recreation Directors",
  "Connecticut Education Association",
  "Connecticut Environmental Health Association",
  "Connecticut Farm Bureau",
  "Connecticut Food Association",
  "Connecticut Hunter Jumper Association",
  "Connecticut Library Association",
  "Connecticut Morgan Horse Association",
  "Connecticut Society of Certified Public Accountants",
  "Connecticut State Police Credit Union",
  "Connecticut State Police Union",
  "Connecticut State USBC Association",
  "Connectional AME Ministers' Spouses, Widows, and Widowers Organization",
  "Conrail",
  "Conservation Federation of Missouri",
  "Construction Industry Center",
  "Construction Management Association of America",
  "Construction Specifications Institute",
  "Convenience Distribution Association",
  "Cool Spring United Methodist Church in Statesville, North Carolina",
  "Cooperative Baptist Fellowship",
  "Cooper Tire & Rubber Company",
  "Coordinating Council for Women in History",
  "Corning Community Band",
  "Correctional Peace Officers Foundation",
  "Corrections Officer",
  "Cory-Rawson High School",
  "Costco Wholesale Canada",
  "Costume Society",
  "Council for Advancement and Support of Education",
  "Council for Exceptional Children",
  "Council for the Advancement of Nursing Science",
  "Council of Elementary Science International",
  "Council of Jewish Organizations in Civil Service",
  "Council of Mexican Federations",
  "Council on Social Work Education",
  "Country Club of Waterbury",
  "Courtney Elementary School",
  "Cox Communications",
  "Cox Media Ohio",
  "Credit Union of Colorado",
  "Croatian Catholic Union of the U.S.A.",
  "Croatian Fraternal Union",
  "Crop Science Society of America",
  "Crown Castle",
  "CSA Fraternal Life",
  "CSW Industrials",
  "CTS Corporation",
  "Cumberland County Farm Bureau",
  "Custom Dental USA",
  "Cutler Associates",
  "Cutler Design",
  "Cyprus Society of Greater Philadelphia",
  "Czech Catholic Union",
  "Dairy Calf and Heifer Association",
  "Dairy Farmers of America",
  "Danish Brotherhood of California",
  "Danish Sisterhood of America",
  "Dante Club of Sacramento",
  "Dare County Fire Department",
  "Daughters of Penelope",
  "Daughters of Rebekah",
  "Daughters of the American Revolution",
  "Daughters of the King",
  "Daughters of Union Veterans of the Civil War 1861-1865",
  "D. Augustus Straker Bar Association",
  "Daybreak Youth Services",
  "Daybreak Youth Services Inpatient Program",
  "Daybreak Youth Services Outpatient Program",
  "Dayton Advertising Club",
  "de Anza Country Club",
  "DECA",
  "Degree of Honor Protective Association",
  "Delaware Academy of Physician Assistants",
  "Delaware Equine Council",
  "Delaware Hugh O'Brian Youth Leadership Program",
  "Delaware Library Association",
  "Delaware National Guard Enlisted Association",
  "Delaware State Education Association",
  "Delaware State Golf Association",
  "Delaware Youth Leadership Network",
  "Delmarva Poultry Association",
  "Delta County Fire Department",
  "Democratic Party",
  "DENSO Manufacturing",
  "Department of Corrections",
  "Dermatology Nurses' Association",
  "Desert Mountain",
  "Desert Mountain Golf Club",
  "Destiny Baptist Church",
  "Detroit Rubber Group",
  "Diabetes Incorporated",
  "Dictionary Society of North America",
  "Digestive Health Specialists",
  "Disabled American Veterans",
  "Disabled American Veterans Auxiliary",
  "Disciples of Christ",
  "Distinguished Flying Cross Society",
  "Distribution Contractors Association",
  "District 1 Texas Association of Extension Home Economists",
  "District of Columbia Library Association",
  "District of Columbia National Guard Enlisted Association",
  "Dixie Pipeline",
  "Doctors Ought to Care",
  "Dollar Bank",
  "Dorchester Base Submarine Veterans",
  "Drug, Chemical, and Allied Trades Association",
  "Ducks Unlimited",
  "Duquesne Club",
  "Eakes Office Solutions",
  "Eastern Amputee Golf Association",
  "Eastern Athletic Trainers Association",
  "Eastern Building Material Dealers Association",
  "Eastern Nursing Research Society",
  "Eastern Orthodox Christian Church",
  "Eastern Surfing Association",
  "Ecological Society of America",
  "Economic History Association",
  "Education",
  "Educational Office Professionals of Ohio",
  "Educators Rising",
  "El Dorado Hills Firefighters Association",
  "Electrical Association of Rochester",
  "Electric League of Missouri and Kansas",
  "Electrochemical Society",
  "Electronic Security Association of Ohio",
  "Electronic Security Association of Utah",
  "Electronic Security Association of Washington",
  "Elizabethtown Hardin County Industrial Foundation Training Consortium",
  "Elks National Foundation",
  "Elks - Broken Bow Area",
  "El Niguel Country Club",
  "Emergency Nurses Association",
  "Emmanuel Baptist Church in Worcester, Massachusetts",
  "Empire Electric Association",
  "Employee Benefits Planning Association",
  "Encompass",
  "Endocrine Society",
  "Engineers' Society of Western Pennsylvania",
  "Enlisted Association National Guard of Arizona",
  "Enlisted Association National Guard of Kansas and Auxiliary",
  "Enlisted Association National Guard of Kentucky",
  "Enlisted Association National Guard of New Jersey",
  "Enlisted Association National Guard of Utah",
  "Enlisted Association of the Arkansas National Guard",
  "Enlisted Association of the National Guard of Georgia",
  "Enlisted Association of the National Guard of Iowa and Auxiliary",
  "Enlisted Association of the National Guard of Montana",
  "Enlisted Association of the National Guard of Tennessee and Auxiliary",
  "Enlisted Association of the National Guard of the United States",
  "Enlisted Association of the National Guard of West Virginia",
  "Enlisted Association of the New York National Guard",
  "Enlisted National Guard Association of Alabama",
  "Enlisted National Guard Association of Florida",
  "Enlisted Spouses Club Seymour Johnson Air Force Base",
  "Enterprise Products Company",
  "Entomological Society of America",
  "Environmental Mutagen Society",
  "Episcopal",
  "Episcopal Church",
  "Episcopal Church in the Diocese of West Virginia",
  "Equitable Reserve",
  "Equity Cooperative Livestock Sales Association",
  "Etruscan Foundation",
  "European Union Studies Association",
  "Evangelical Lutheran Church",
  "Evans Roofing",
  "Everence",
  "Evrytanian Association of America",
  "Exhibit Designers and Producers Association",
  "Experimental Aircraft Association",
  "Express-News",
  "Extension Association of New Mexico",
  "Fabricators and Manufacturers Association",
  "Fairfield-Suisun Management Association",
  "Fairfield-Suisun Unified Teachers Association",
  "Fairfield Women in Action",
  "Faith Technologies",
  "Family and Consumer Sciences Teachers Association of Texas",
  "Family Campers and Rvers",
  "Family, Career and Community Leaders of America",
  "Farm Bureau",
  "Farm Credit Services of Mid-America",
  "FarmFirst Dairy Cooperative",
  "Far West Agribusiness Association",
  "Fayette County Firefighters Association",
  "Fayetteville Fire Department",
  "FCS Financial",
  "Federal Asian Pacific American Council",
  "Federal Aviation Administration",
  "Federal Aviation Administration Managers Association",
  "Federal Bar Association",
  "Federally Employed Women",
  "Federal Managers Association",
  "Federal/State Recognized Tribe",
  "Federated Car Care Centers",
  "Federation of American Consumers and Travelers",
  "Federation of Straight Chiropractors and Organizations",
  "Feingold Companies",
  "Fellowship of Christian Athletes",
  "Ferri Enterprises",
  "Fieri International",
  "Fifth Marine Division Association",
  "Filipino-American Community of Colorado",
  "Financial Women International",
  "Findlay City Schools",
  "Findlay High School",
  "Fire Cadet Program",
  "Fire Department",
  "Firefighter",
  "Firefighters Association",
  "First Baptist Church of Charleston, West Virginia",
  "First Baptist Church, Richmond, Virginia",
  "First Catholic Slovak Ladies Association",
  "First Catholic Slovak Union",
  "First Cavalry Division Association",
  "First Christian Church in Mattoon, Illinois",
  "First Church of God in Columbus, Ohio",
  "First Congregational Church in Saginaw, Michigan",
  "Firstmark Credit Union",
  "First Presbyterian Church",
  "FIRST Program",
  "First United Methodist Church of Pampa",
  "First Ward Community Center",
  "Fishel Company",
  "Fleet Reserve Association",
  "Flexographic Technical Association",
  "Florida Academy of Nutrition and Dietetics",
  "Florida Academy of Physician Assistants",
  "Florida Association for Media in Education",
  "Florida Association of Cadastral Mappers",
  "Florida Association of Family and Consumer Sciences",
  "Florida Association of Neonatal Nurse Practitioners",
  "Florida Association of Nurse Anesthetists",
  "Florida Education Association",
  "Florida Engineering Society",
  "Florida Environmental Health Association",
  "Florida Farm Bureau Federation",
  "Florida Funeral Directors Association",
  "Florida High School Rodeo Association",
  "Florida Independent Concrete and Associated Products",
  "Florida Institute of CPAs",
  "Florida Land Title Association",
  "Florida League for Nursing",
  "Florida Library Association",
  "Florida Occupational Therapy Association",
  "Florida Organization of Nurse Executives",
  "Florida Petroleum Marketers and Convenience Store Association",
  "Florida Public Health Association",
  "Florida Public Relations Association",
  "Florida Roofing, Sheet Metal, and Air Conditioning Contractors Association",
  "Florida Safety Council",
  "Florida School Counselor Association",
  "Florida School Nutrition Association",
  "Florida SouthWestern State College",
  "Florida State Golf Association",
  "Florida State Horticultural Society",
  "Florida Surveying and Mapping Society",
  "Florida Teaching Profession<N1>National Education Association",
  "Florida Thoroughbred Breeders' and Owners' Association",
  "Florida Transportation Builders' Association",
  "Food Processing Suppliers Association",
  "Food Shippers of America",
  "Force Recon Association",
  "Foremost Farms USA",
  "Foresters Financial",
  "Forever Friends - Longview Area",
  "Forman S. Acton Acorn Fund",
  "Forsyth Audubon Society",
  "Forsyth County Sheriff's Office",
  "Forsyth Municipal ABC Law Enforcement",
  "Fort Gordon Spouses' and Civilians' Club",
  "Fort Huachuca Community Spouses' Club",
  "Fort Knox Spouses and Community Club",
  "Fort Leavenworth Spouses' Club",
  "Fort Lee Area Spouses' Club",
  "Fort Meade Officers' Spouses' Club",
  "Fort Polk Spouses' Club",
  "Fort Rucker Community Spouses' Club",
  "Fort Shafter Hui",
  "Fort Wayne Rubber and Plastics Group",
  "Foundation for Amateur Radio",
  "Fourth Marine Division Association",
  "Frankenmuth Convalescent Center",
  "Frankenmuth Lutheran Home",
  "Franklin County Residential Services",
  "Fraternal Order of Eagles",
  "Fraternal Order of Police",
  "Fraternal Order Orioles",
  "Fraternity",
  "Freeland SportsZone",
  "French Association of University Women",
  "Fresh Encounter",
  "FRESH New London",
  "Friendly House",
  "Fundacao Faialense",
  "Future Business Leaders of America",
  "Future Educators of America",
  "Future Farmers of America",
  "Future Teachers of America",
  "Gamewardens Association, Vietnam to Present",
  "Gannett Fleming",
  "Garden State Federation of Pennsylvania",
  "Gardner Dam Camp",
  "Garfield County Fire Department",
  "Gases and Welding Distributors Association",
  "Gateway Hemophilia Association",
  "Gay and Lesbian Medical Association",
  "Gay & Lesbian Youth Services of Western New York",
  "GBU Financial Life",
  "GEMS",
  "Gene B. Glick Company",
  "General Federation of Women's Clubs",
  "Genetics Society of America",
  "Geological Society of America",
  "Georgia Association for Health, Physical Education, Recreation and Dance",
  "Georgia Association for Nursing Education",
  "Georgia Association of Convenience Stores",
  "Georgia Association of Educators",
  "Georgia Association of Family and Consumer Sciences",
  "Georgia Association of Latin American Journalists",
  "Georgia Association of Nursing Students",
  "Georgia Association of Physician Assistants",
  "Georgia Association of Water Professionals",
  "Georgia Business Education Association",
  "Georgia Cattlemen's Association",
  "Georgia Electronic Membership Corporation",
  "Georgia Farm Bureau",
  "Georgia Golf Course Superintendents Association",
  "Georgia Government Finance Officers Association",
  "Georgia Hunting and Fishing Federation",
  "Georgia Junior Cattlemen's Association",
  "Georgia Junior Swine Boosters",
  "Georgia Library Media Association",
  "Georgia Nurses Association",
  "Georgia Ornithological Society",
  "Georgia School Nutrition Association",
  "Georgia Securities Association",
  "Georgia Simmental/Simbrah Association",
  "Georgia State Firefighters Association",
  "Georgia State Golf Association",
  "Geothermal Rising",
  "Germans From Russia Heritage Society",
  "Gerontological Advanced Practice Nurses Association",
  "Gerontological Society of America",
  "Girl Scouts of America",
  "Girls, Inc.",
  "Glades County Sheriff's Office",
  "Glass, Molders, Pottery, Plastics and Allied Workers International Union",
  "Gleaner Life Insurance Society",
  "Glendale Christian Church",
  "Goals Program",
  "Golden Key",
  "Golden State Restaurant Association",
  "Golf Course Superintendents Association of Central California",
  "Golf Course Superintendents Association of New Jersey",
  "Golf Course Superintendents Association of Northern California",
  "Golf Course Superintendents Association of Southern California",
  "Goodfellow Bros.",
  "Grace Lutheran Church in Larsen, Wisconsin",
  "Grace Pacific Outstanding Keiki Scholars Program",
  "Graduate Nursing Student Academy",
  "Grange",
  "Graphic Communications International Union",
  "Greater Philadelphia Law Library Association",
  "Greater Sarasota Junior Golf Association",
  "Greek Organization",
  "Greek Orthodox Church of Springfield, Ohio",
  "Greek Orthodox Faith",
  "Green Oaks Country Club",
  "Green Party",
  "Gunnison County Electric Association",
  "Gynecologic Cancer Foundation",
  "Habitat for Humanity",
  "HACEMOS (Hispanic/Latino Employee Association of AT&T)",
  "Hancock County Educational Service Center",
  "Hancock Federal Credit Union",
  "Handweavers Guild of America",
  "Hardin County Water District No. 2",
  "Harmony Lodge 8",
  "Harness Horsemen International",
  "Harness Horse Youth Foundation",
  "Hawaiian Airlines",
  "Hawaiian Electric Industries",
  "Hawaii Area Submarine Force",
  "Hawaii Asphalt Paving Industry",
  "Hawaii Athletic Trainers Association",
  "Hawaii Carpenters Union Local 745",
  "Hawaii Civic Club",
  "Hawaii Education Association",
  "Hawai’i Lodging and Tourism Association",
  "Hawai’i National Guard Enlisted Association",
  "Hawai’i Nurses Association",
  "Hawaii State Junior Golf Association",
  "HawaiiUSA Federal Credit Union",
  "Healthcare",
  "Healthcare Financial Management Association",
  "Healthcare Information and Management Systems Society",
  "Health Physics Society",
  "Hearing Loss Association of America",
  "Heartland Co-op",
  "Heart of America Golf Course Superintendents Association",
  "Hellenic University Club of Philadelphia",
  "Hemophilia Association of the Capital Area",
  "Hemophilia of Iowa",
  "Hemophilia Society of Colorado",
  "Hemophilia Society of New Jersey",
  "Hendry County Sheriff's Office",
  "Heritage Acceptance Corporation",
  "Heritage Financial Group",
  "Herpetologists League",
  "HFM Foodservice",
  "Highland Presbyterian Church",
  "Hilcorp",
  "Hi-Lo Desert Golf Course Superintendents Association",
  "Hilo Hoyukai",
  "Hindu Bhavan",
  "Hispanic American Police Command Officers Association",
  "Hispanic Bar Association of Houston",
  "Hispanic Dental Association",
  "Hispanic National Bar Association",
  "Hispanic Organization of Toxicologists",
  "Histochemical Society",
  "Historians of Eighteenth Century Art and Architecture",
  "HIV Medical Association",
  "Holland Lop Rabbit Specialty Club",
  "Hollis Nor'Easters Snowmobile Club",
  "Holstein Association USA",
  "Home Builders and Remodelers Association of Western Massachusetts",
  "Home Builders Association of Fayetteville",
  "Home Builders Association of Greater Charleston",
  "Home Builders Association of Puerto Rico",
  "Home Choice",
  "Home Depot",
  "Home Educators Association of Virginia",
  "Home Schoolers Association",
  "Homeschoolers' Support Association",
  "Honolulu Japanese Chamber of Commerce Charitable Corporation",
  "Honor Guard Program",
  "Hoof Trimmers Association",
  "Hopi Nation",
  "Hornady Manufacturing",
  "Horror Writers Association",
  "HOSA Future Health Professionals",
  "Hospice and Palliative Nurses Association",
  "Hot Springs High School, Truth Or Consequences, New Mexico",
  "House of Blahnik",
  "Houston Area Law Librarians",
  "Houston Country Club",
  "Houston Transportation Professionals Association",
  "Hoyt Nursing Home",
  "Hubbard-Hall",
  "Hughes Federal Credit Union",
  "Hui ‘O Na Wahine",
  "Human Options",
  "Hutchinson Oil Company",
  "Hutch's C-Store",
  "I Am Boundless",
  "I Am Boundless Affiliated Organization",
  "IBEW 557",
  "Ice Skating Institute of America",
  "iContact",
  "Idaho Athletic Trainers' Association",
  "Idaho Cattle Association",
  "Idaho Enlisted Association",
  "Idaho Farm Bureau Federation",
  "Idaho Golf Association",
  "Idaho Golf Course Superintendents Association",
  "Idaho Grower Shippers Association",
  "Idaho Library Association",
  "Idaho Nurses Association",
  "Idaho Public Health Association",
  "Idaho State Broadcasters Association",
  "Idle Hour Country Club",
  "I Have A Dream Southwest Washington Program",
  "Illinois Association for Health, Physical Education, Recreation and Dance",
  "Illinois Association for Home and Community Education",
  "Illinois Association for Parents of Children with Visual Impairments",
  "Illinois Association of Highway Engineers",
  "Illinois Association of School Nurses",
  "Illinois Athletic Directors Association",
  "Illinois Athletic Trainers' Association",
  "Illinois Beef Association",
  "Illinois Business Education Association",
  "Illinois Cheerleading Coaches Association",
  "Illinois Council for Exceptional Children",
  "Illinois Court Reporters Association",
  "Illinois Farm Bureau",
  "Illinois Federation of Teachers",
  "Illinois Jaycees",
  "Illinois Junior Golf Association",
  "Illinois Library Association",
  "Illinois News Broadcasters Association",
  "Illinois Nurses Association",
  "Illinois Occupational Therapy Association",
  "Illinois Pork Producers Association",
  "Illinois Realtors Association",
  "Illinois Retired Teachers Association",
  "Illinois Society of Professional Engineers",
  "Illinois State Bar Association",
  "Illuminating Engineering Society",
  "Illuminators Educational Foundation",
  "Ilocano America Association of Nevada",
  "Independent Automobile Dealers Association of California",
  "Independent Cattlemen's Association",
  "Independent Insurance Agents of Oklahoma",
  "Independent Jewelers Organization",
  "Independent Order of Svithiod",
  "Independent Party",
  "Indiana Athletic Trainers Association",
  "Indiana Correctional Association",
  "Indiana CPA Society",
  "Indiana Extension Homemakers Association",
  "Indiana Farm Bureau",
  "Indiana Funeral Directors Association",
  "Indiana Grain and Feed Association",
  "Indiana Horse Council",
  "Indiana Interscholastic Athletic Administrators Association",
  "Indiana Junior Beef Cattle Association",
  "Indiana National Guard",
  "Indiana Organization of Nurse Executives",
  "Indiana Osteopathic Association",
  "Indiana Plant Food and Ag Chemical Association",
  "Indiana Sheriffs' Association",
  "Indiana Society for Health and Physical Educators",
  "Indiana Society of Mayflower Descendants",
  "Indiana Standardbred Association",
  "Indiana State Bar Association",
  "Indiana State Nurses Association",
  "Indiana State Teachers Association",
  "Indiana Teachers of English to Speakers of Other Languages",
  "Indian National Finals Rodeo",
  "Industrial Designers Society of America",
  "Industrial Fabrics Association International",
  "Industrial Supply Association",
  "Infectious Diseases Society of America",
  "InfoComm International",
  "Infusion Nurses Society",
  "Installed Building Products",
  "Institute for Supply Management-Connecticut",
  "Institute of Biological Engineering",
  "Institute of Electrical and Electronics Engineers",
  "Institute of Food Technologists",
  "Institute of Industrial and Systems Engineers",
  "Institute of Management Accountants",
  "Institute of Mathematical Statistics",
  "Institute of Medicine",
  "Institute of Navigation",
  "Institute of Noise Control Engineering",
  "Institute of Scrap Recycling Industries",
  "Institute of Transportation Engineers",
  "Instrument Sales & Services",
  "Insulate America",
  "Interact, Rotary Club",
  "Inter-American Bar Association",
  "Intercollegiate Horse Show Association",
  "Intercollegiate Studies Institute",
  "Intermountain Electrical Association",
  "International Alliance for Women in Music",
  "International Alliance of Theatrical Stage Employees and Moving Picture Technicians, Artists and Allied Crafts of the United States of America",
  "International Art Materials Trade Association",
  "International Association for China Planning",
  "International Association for Dental Research",
  "International Association for Great Lakes Research",
  "International Association for the Exchange of Students for Technical Experience",
  "International Association of Administrative Professionals",
  "International Association of Arson Investigators",
  "International Association of Bridge, Structural, Ornamental and Reinforcing Iron Workers Locals 48 Member",
  "International Association of EMTs and Paramedics",
  "International Association of Fire Chiefs",
  "International Association of Fire Fighters",
  "International Association of Forensic Nurses",
  "International Association of Heat and Frost Insulators and Asbestos Workers Local 66",
  "International Association of Heat and Frost Insulators and Asbestos Workers Local 94",
  "International Association of Insurance Professionals",
  "International Association of Lighting Designers",
  "International Association of Machinists and Aerospace Workers",
  "International Association of Sheet Metal, Air, Rail and Transportation Workers",
  "International Association of Special Investigation Units",
  "International Association of Structural Movers",
  "International Association of Students in Economics and Management",
  "International Association of Wildland Fire",
  "International Atherosclerosis Society",
  "International Biometric Society",
  "International Brotherhood of Boilermakers, Iron Ship Builders, Blacksmiths, Forgers and Helpers",
  "International Brotherhood of Correctional Officers",
  "International Brotherhood of Electrical Workers",
  "International Brotherhood of Electrical Workers Locals 1141",
  "International Brotherhood of Electrical Workers Locals 444",
  "International Brotherhood of Police Officers",
  "International Brotherhood of Teamsters",
  "International Buckskin Horse Association",
  "International Cast Polymer Association",
  "International Chemical Workers Union",
  "International Chiropractors Association",
  "International Cinematographers Guild",
  "International Communications Association",
  "International Concrete Repair Institute",
  "International Council of Shopping Centers",
  "International Council on Monuments and Sites",
  "International Dairy-Deli-Bakery Association",
  "International Desalination Association",
  "International Double Reed Society",
  "International Facility Management Association",
  "International Federation of Professional and Technical Engineers",
  "International Federation of University Women",
  "International Flight Services Association",
  "International Food Service Executives Association",
  "International Furnishings and Design Association",
  "International Interior Design Association",
  "International Junior Brangus Breeders Association",
  "International Literacy Association",
  "International Longshoremen's Association",
  "International Maintenance Institute",
  "International Metal Decorators Association",
  "International Military Community Executives Association",
  "International Military Community Executives' Association",
  "International Nurses Society on Addictions",
  "International Order of Job's Daughters",
  "International Order of Odd Fellows",
  "International Order of Rainbow for Girls",
  "International Organization of Good Templars",
  "International Organization of Masters, Mates and Pilots",
  "International Organization of Multiple Sclerosis Nurses",
  "International Personnel Management Association",
  "International Phycological Society",
  "International Publishing Management Association",
  "International Right of Way Association",
  "International Safety Equipment Association",
  "International Society for Computational Biology",
  "International Society of Arboriculture",
  "International Society of Automation",
  "International Society of Offshore and Polar Engineers",
  "International Society of Psychiatric-Mental Health Nurses",
  "International Technology and Engineering Educators Association",
  "International Textile and Apparel Association",
  "International Thespian Society",
  "International Union for the Study of Social Insects",
  "International Union of Bricklayers and Allied Craftworkers",
  "International Union of Bricklayers And Allied Craftworkers Local 5",
  "International Union of Electronic, Electrical, Salaried, Machine, and Furniture Workers",
  "International Union of Elevator Constructors Local 63",
  "International Union of Operating Engineers",
  "International Union of Operating Engineers Local 627",
  "International Union of Painters And Allied Trades",
  "International Union of Painters And Allied Trades Local 807",
  "International Union of Police Associations",
  "Iowa Arabian Horse Association",
  "Iowa Association for Health, Physical Education, Recreation and Dance",
  "Iowa Association of Agricultural Educators",
  "Iowa Association of Nursing Students",
  "Iowa Association of Women Police",
  "Iowa Athletic Trainers Society",
  "Iowa Communications Alliance",
  "Iowa Corn Growers Association",
  "Iowa Farm Bureau Federation",
  "Iowa Girls' Coaches Association",
  "Iowa Golf Course Superintendents Association",
  "Iowa Grocery Industry Association",
  "Iowa Horse Council",
  "Iowa Jersey Cattle Club",
  "Iowa Junior Beef Breeds Council",
  "Iowa League for Nursing",
  "Iowa Library Association",
  "Iowa Narcotics Officers Association",
  "Iowa Nurse Practitioner Society",
  "Iowa Nurses Association",
  "Iowa Organization of Nurse Leaders",
  "Iowa Pork Producers Association",
  "Iowa Soybean Association",
  "Iowa Sports Turf Managers Association",
  "Iowa State Education Association",
  "Iowa State Sheriffs' and Deputies' Association",
  "Iowa Trappers Association",
  "Iron Workers",
  "Iron Workers Local 48",
  "Iron Workers Local 584",
  "Islamic Institute of Orange County",
  "Island Gourmet Markets",
  "Island Holdings",
  "Italian American Heritage Foundation",
  "Italian Catholic Federation",
  "Italian Charities of America",
  "Italian Heritage Society of Indiana",
  "Italian Sons and Daughters of America",
  "Japanese American Citizens League",
  "Japanese American Service Committee",
  "Japanese American Veterans Association",
  "Japanese Medical Society of America",
  "Jazz Education Network",
  "Jefferson Awards YSI Program",
  "Jehovah's Witness",
  "Jewelers Mutual Insurance Company",
  "Jewish Community",
  "Jewish Faith",
  "Jewish Teachers Association",
  "Jewish War Veterans",
  "JHHS Archery Team",
  "John L. Santikos Companies",
  "Johnson Insurance",
  "Journalism Education Association",
  "J. Robert Gladden Orthopaedic Society",
  "JROTC",
  "Judicial Professional Employees Association",
  "Junior Achievement",
  "Junior Beefmaster Breeders Association",
  "Junior Course Superintendents Association of America",
  "Justinian Society",
  "Kahala Nui",
  "Kailua Hawaiian Civic Club",
  "Kamehameha Schools Food Services Department",
  "Kansas Association for Health, Physical Education, Recreation and Dance",
  "Kansas Association of Broadcasters",
  "Kansas Association of Educational Office Professionals",
  "Kansas Association of Nursing Students",
  "Kansas Association of School Librarians",
  "Kansas Athletic Trainers Society",
  "Kansas Business Education Association",
  "Kansas Corn Growers Association",
  "Kansas Environmental Health Association",
  "Kansas Fairs and Festivals Association",
  "Kansas Farm Bureau",
  "Kansas Health Information Management Association",
  "Kansas High School Rodeo Association",
  "Kansas Horse Council",
  "Kansas Library Association",
  "Kansas Livestock Association/Kansas Junior Livestock Association",
  "Kansas Occupational Therapy Association",
  "Kansas Peace Officers' Association",
  "Kansas School Nurse Organization",
  "Kansas Sheriffs' Association",
  "Kansas State Nurses Association",
  "Kansas Women's Golf Association",
  "Kappa Alpha Theta",
  "Kappa Delta Rho",
  "Kappa Instructional Leadership League",
  "Kappa Instructional Leadership League Saginaw Alumni Chapter",
  "Kappa Kappa Iota",
  "Kappa Sigma",
  "Katolicka Jednota Zen Texaskych",
  "K.C. Electric Association",
  "Keiser University",
  "Kenmawr United Presbyterian Church",
  "Kentucky Association for Pupil Transportation",
  "Kentucky Association of Highway Contractors",
  "Kentucky Association of Professional Educators",
  "Kentucky Association of Professional Surveyors",
  "Kentucky Association of School Librarians",
  "Kentucky Athletic Trainers' Society",
  "Kentucky Cattlemen's Association",
  "Kentucky Coalition of Nurse Practitioners and Nurse Midwives",
  "Kentucky Corn Growers Association",
  "Kentucky Council on Crime and Delinquency",
  "Kentucky Crushed Stone Association",
  "Kentucky Education Association",
  "Kentucky Equine Education Project",
  "Kentucky Extension Homemakers Association",
  "Kentucky Farm Bureau",
  "Kentucky Firefighters Association",
  "Kentucky Grocers and Convenience Store Association",
  "Kentucky High School Coaches Association",
  "Kentucky Horse Council",
  "Kentucky League for Nursing",
  "Kentucky Library Association",
  "Kentucky Medical Association",
  "Kentucky Nurses Association",
  "Kentucky Occupational Therapy Association",
  "Kentucky Organization of Pep Organization Sponsors",
  "Kentucky Poultry Federation",
  "Kentucky Professional Firefighters Association",
  "Kentucky Propane Gas Association",
  "Kentucky Public Health Association",
  "Kentucky Quarter Horse Youth Association",
  "Kentucky Society of Certified Public Accountants",
  "Kentucky Society of Professional Engineers",
  "Kentucky Speech-Language-Hearing Association",
  "Kentucky Transportation Employees' Association",
  "Kentucky Turfgrass Council",
  "Kern County Cattlemen's Association",
  "Kern County CattleWomen",
  "Key Club",
  "Keyes Packaging Group",
  "Kilwin's of San Antonio",
  "Kings County Farm Bureau",
  "Kiwanis Club of Battle Creek",
  "Kiwanis International",
  "Knights of Columbus",
  "Knights of Lithuania",
  "Knights of Peter Claver",
  "Knights of Pythagoras",
  "Knights of Pythias",
  "Knights of Vartan",
  "Knoxville Track Club",
  "Kohala Filipina Community Association",
  "Kona Hawaiian Civic Club",
  "Korean American Bar Association of San Diego",
  "Korean American Medical Student Association",
  "Korean American Scientists and Engineers Association",
  "Korean Nurses Association of Southern California",
  "Korean War Veterans Association",
  "KSKJ Life",
  "Kukio Community Association",
  "Kukio Golf and Beach Club",
  "Kukio Staffing Services",
  "Kyte Enterprises",
  "Laborers' District Council of Ohio",
  "Laborers' International Union of North America Local 107",
  "Ladies Auxiliary of the Fleet Reserve Association",
  "Ladies of the Grand Army of the Republic",
  "Ladies Pennsylvania Slovak Catholic Union",
  "Lady Devils",
  "Lakeside Country Club",
  "Lancaster County Industrial Safety Council",
  "Land Improvement Contractors of America",
  "Land of Lincoln Purebred Livestock Breeders Association",
  "Landus Cooperative",
  "Lanxess Canada",
  "Lao American New Generation",
  "Latin American Support Organization",
  "Latino Medical Student Association",
  "Law and Society Association",
  "Law Librarians Association of Wisconsin",
  "Law Librarians of New England",
  "Law Librarians of Puget Sound",
  "Law Library Association of Greater New York",
  "Learning Disabilities Association of California",
  "Learning Disabilities Association of Iowa",
  "Learning Disabilities Association of Kansas",
  "Lee County Sheriff's Office",
  "Legacy Farmers Cooperative",
  "Legacy Scholars Program",
  "Legal Support Professionals of Arizona",
  "Leicester High School Football Team",
  "LGBTQ+ Community",
  "LGS Innovations",
  "Libertarian Party",
  "Liberty-Benton High School",
  "Library Association of Alberta",
  "Library Association of Rockland County",
  "Library Nova Scotia Association",
  "Licensed Site Professional Association",
  "Licensed Vocational Nurses Association of Texas",
  "Lincoln Community High School",
  "Linworth Experiential Program",
  "Lithuanian Alliance of America",
  "Lithuanian Foundation",
  "Little People of America",
  "Littletown Foundry",
  "Logistics and Transportation Association of North America",
  "Long Island Builders Institute",
  "Long Island School Media Association",
  "Longmeadow High School Swim Team",
  "Longwood at Oakmont Retirement Community",
  "Los Angeles Geographical Society",
  "Los Angeles Hunter Jumper Association",
  "Los Angeles Transportation Club",
  "Louisiana Archives and Manuscripts Association",
  "Louisiana Association of Nurse Practitioners",
  "Louisiana Association of Student Nurses",
  "Louisiana Bankers Association",
  "Louisiana Early Childhood Association",
  "Louisiana Farm Bureau",
  "Louisiana Health Information Management Association",
  "Louisiana High School Coaches Association",
  "Louisiana Library Association",
  "Louisiana Mississippi Golf Course Superintendents Association",
  "Louisiana National Guard Enlisted Association",
  "Louisiana Occupational Therapy Association",
  "Louisiana Public Health Association",
  "Louisiana Recreation and Park Association",
  "Louisiana State Nurses Association",
  "Love's Travel Stops & Country Stores",
  "Love's United Methodist Church",
  "Loyal Christian Benefit Association",
  "Lumber Dealers Association of Connecticut",
  "Luso-American Fraternal Federation",
  "Lutheran",
  "Lutheran Brotherhood",
  "Lutheran Church",
  "Lutheran Church of Our Redeemer in Petersburg, Virginia",
  "Luther Manor",
  "M.A.B.A.S. Division 8 Fire Departments",
  "MacDill Enlisted Spouses' Club",
  "Macedonia Missionary Baptist Church",
  "MacLellan Services",
  "Macon-Bibb County Fire Department",
  "Madera County Cattlemen's Association",
  "Madera County Cattlewomen's Association",
  "Magnetics Society",
  "Maids of Athena",
  "Maine Antique Tractor Club",
  "Maine Association of School Librarians",
  "Maine Athletic Trainers' Association",
  "Maine Chiefs of Police Association",
  "Maine Christmas Tree Association",
  "Maine Driver Education Association",
  "Maine Golf Course Superintendents Association",
  "Maine Grocers and Food Producers Association",
  "Maine Innkeepers Association",
  "Maine Library Association",
  "Maine Mayflower Society",
  "Maine School Nutrition Association",
  "Maine Skating Club",
  "Maine Society of Health-System Pharmacists",
  "Maine State Employees Association",
  "Maine State Grange",
  "Maine State Nurses Association",
  "MANA, A National Latina Organization",
  "Manchester Volunteer Rescue Squad",
  "Manufactured Housing Communities",
  "Manufacturers and Tent Renters Association",
  "Maravilla Scottsdale",
  "Margaret Hall",
  "Margaret Hall Alumni",
  "Marine Corps Aviation Association",
  "Marine Corps Counterintelligence Association",
  "Marine Corps Intelligence Association",
  "Marine Corps League/Auxiliary",
  "Marine Corps Tanker Association",
  "Marines' Memorial Association",
  "Marine Technology Society",
  "Marine Trades Association of New Jersey",
  "Mark Neumeier Youth Center",
  "Mark Twain High School",
  "Marne Community and Spouses Club",
  "Marsh Clearsight",
  "Martin Luther Home",
  "Martin Resorts",
  "Maryland Academy of Nutrition and Dietetics",
  "Maryland Academy of Physician Assistants",
  "Maryland Association for Health, Physical Education, Recreation and Dance",
  "Maryland Farm Bureau",
  "Maryland Fur Trappers",
  "Maryland Healthcare Human Resources Association",
  "Maryland Horse Shows Association",
  "Maryland Library Association",
  "Maryland Nurses Association",
  "Maryland State Golf Association",
  "Maryland & Virginia Milk Producers Cooperative Association",
  "Masonic Cluster Lodge",
  "Masonic Custer Lodge 148 Broken Bow",
  "Masonic Youth",
  "Masons",
  "Massachusetts Dietetic Association",
  "Massachusetts Farm Bureau",
  "Massachusetts Federation of Polish Women's Clubs",
  "Massachusetts Foreign Language Association",
  "Massachusetts Horsemen's Council",
  "Massachusetts Independent Automobile Dealers Association",
  "Massachusetts LGBTQ Bar Association",
  "Massachusetts Medical Society",
  "Massachusetts Morgan Horse Association",
  "Massachusetts Nurses Association",
  "Massachusetts Occupational Therapy Association",
  "Massachusetts Organization of Nurse Executives",
  "Massachusetts Policy Association",
  "Massachusetts Retail Lumber Dealers Association",
  "Massachusetts School Library Media Association",
  "Massachusetts School Nurse Organization",
  "Massachusetts Society of Certified Public Accountants",
  "Massachusetts State Grange",
  "Master Brewers Association of the Americas",
  "Materials Research Society",
  "Mathematical Association of America",
  "Maui Okinawa Kenjin Kai",
  "McComb Local High School",
  "McNeil High School Girls Golf Team",
  "Meadow Gold Dairies - Hawaii",
  "Medical Group Management Association",
  "Medical Library Association",
  "Medical Society of New Jersey Student Association",
  "Medieval Academy of America",
  "Meijer",
  "Member Company of Arizona Multihousing Association",
  "Mennonite",
  "Men of Vision",
  "Mensa",
  "Merced-Mariposa Cattlemen's Association",
  "Mesa County Fire Department",
  "Methodist",
  "Methodist Church",
  "Methodist Stone Oak Hospital",
  "Metrolina Native American Association",
  "Metropolitan Fastener Distributors Association",
  "Metropolitan Golf Course Superintendents Association",
  "Metropolitan Society of Kardamylians",
  "MGK Technologies",
  "MH Acceptance",
  "Michigan Aggregates Association",
  "Michigan AgriBusiness Association",
  "Michigan Association for Health, Physical Education, Recreation and Dance",
  "Michigan Association of Fairs and Exhibitions",
  "Michigan Association of Fire Fighters",
  "Michigan Association of Police",
  "Michigan Association of Public Employees",
  "Michigan Athletic Trainers Society",
  "Michigan Automotive Parts Association",
  "Michigan Bear Hunters Association",
  "Michigan Boating Industries Association",
  "Michigan Corn Growers Association",
  "Michigan Council of Women in Technology",
  "Michigan Educational Support Personnel Association",
  "Michigan Education Association",
  "Michigan Federation of Teachers and School Related Personnel",
  "Michigan Golf Course Superintendents Association",
  "Michigan Grocers Association",
  "Michigan Harness Horsemen's Association",
  "Michigan Health Sciences Library Association",
  "Michigan High School Rodeo Association",
  "Michigan Horse Council",
  "Michigan Hunter Jumper Association",
  "Michigan League for Nursing",
  "Michigan Library Association",
  "Michigan Llama Association",
  "Michigan Nurses Association",
  "Michigan Occupational Therapy Association",
  "Michigan Organization of Nurse Executives",
  "Michigan Paralyzed Veterans of America",
  "Michigan Pharmacists Association",
  "Michigan Professional Fire Fighters Union",
  "Michigan Public School",
  "Michigan Retailers Association",
  "Michigan Shell Jobbers",
  "Michigan Society of Professional Engineers",
  "Michigan Sugar Company",
  "Michigan Water Environment Association",
  "Microscopy Society of America",
  "Mid-Atlantic Association for Employment in Education",
  "Mid-Atlantic Association of Golf Course Superintendents",
  "MidAtlantic Farm Credit",
  "MidAtlantic Rubber and Plastics Group",
  "Middle East Studies Association of North America",
  "Midland County Sheriff's Office",
  "Mid-New Jersey Youth Soccer Association",
  "Mid-Ohio District Nurses Association",
  "Midwest Association of Golf Course Superintendents",
  "Midwest Association of Rail Shippers",
  "Midwest Automotive Parts and Service Association",
  "Midwest Coast Transport",
  "Midwest Conference on Asian Affairs",
  "Midwestern Amputee Golf Association",
  "Midwest Federation of American Syrian-Lebanese Clubs",
  "Midwest Food Processors Association",
  "Midwest Hemophilia Association",
  "Midwest Independent Retailers Association",
  "Midwest Nursing Research Society",
  "Midwest Victorian Studies Association",
  "Milford Water",
  "Military Benefit Association",
  "Military Intelligence Corps Association",
  "Military Officers Association of America",
  "Military Order of Purple Heart",
  "Military Order of the Stars and Bars",
  "Miller Fabrication Solutions",
  "Mind's Eye Society",
  "Mineralogical Society of America",
  "Minnesota Academy of Nutrition and Dietetics",
  "Minnesota Academy of Physician Assistants",
  "Minnesota American Indian Bar Association",
  "Minnesota Association for Developmental Education",
  "Minnesota Association for Health, Physical Education, Recreation, and Dance",
  "Minnesota Association of Law Libraries",
  "Minnesota Association of Occupational Health Nurses",
  "Minnesota Benefit Association",
  "Minnesota Corrections Association",
  "Minnesota Farm Bureau",
  "Minnesota Farmers Union",
  "Minnesota Golf Course Superintendents' Association",
  "Minnesota Grocers Association",
  "Minnesota High School Rodeo Association",
  "Minnesota Junior Angus Association",
  "Minnesota Laborers Union",
  "Minnesota Marketing Business Information Technology Educators",
  "Minnesota Medical Society",
  "Minnesota National Guard Enlisted Association and Auxiliary",
  "Minnesota Nurses Association",
  "Minnesota Onsite Wastewater Association",
  "Minnesota Organization of Leaders in Nursing",
  "Minnesota Saddlebred Horse Association",
  "Minnesota School Counselor Association",
  "Minnesota State Archery Association",
  "Minnesota Subcontractors Association",
  "Minnesota Trappers Association",
  "Minnesota Trucking Association",
  "Minnesota Turkey Growers Association",
  "Minnesota Utility Contractors Association",
  "Mississippi Association of Student Nurses",
  "Mississippi Cattlemen's/CattleWomen's Association",
  "Mississippi Early Childhood Association",
  "Mississippi Farm Bureau",
  "Mississippi High School Rodeo Association",
  "Mississippi National Guard NCO Association",
  "Mississippi Nurses Association",
  "Mississippi School Nutrition Association",
  "Mississippi Thespians",
  "Mississippi Trucking Association",
  "Mississippi Valley Golf Course Superintendents Association",
  "Missouri Academy of Nutrition and Dietetics",
  "Missouri Association of School Librarians",
  "Missouri Cattlemen's Association",
  "Missouri Council of the Blind",
  "Missouri Farm Bureau",
  "Missouri Junior Angus Association",
  "Missouri Library Association",
  "Missouri National Guard Association and Auxiliary",
  "Missouri Occupational Therapy Association",
  "Missouri Public Health Association",
  "Missouri Society of Certified Public Accountants",
  "Missouri State Medical Association",
  "Missouri State Teachers Association",
  "Model A Ford Club of America",
  "Modern Business Machines",
  "Modern Greek Studies Association",
  "Modern Language Association",
  "Modern Woodmen of America",
  "Modoc County Cattlemen and Cattlewomen",
  "Moffat County Fire Department",
  "Montana CattleWomen",
  "Montana Contractors' Association",
  "Montana Farm Bureau Federation",
  "Montana Farmers Union",
  "Montana Federation of Public Employees",
  "Montana Food Distributors Association",
  "Montana Grain Growers Association",
  "Montana High School Rodeo Association",
  "Montana Library Association",
  "Montana Nursery and Landscape Association",
  "Montana Police Protective Association",
  "Montana School Nutrition Association",
  "Montana Society of Certified Public Accountants",
  "Montana State Golf Association",
  "Montana Trappers Association",
  "Monterey Bay Officers' Spouses Club",
  "Monterey County Vintners and Growers Association",
  "Montrose County Fire Department",
  "Moose International",
  "Moravian",
  "Mormon",
  "Mortar Board",
  "Mortgage Bankers Association of the Carolinas",
  "Moslem",
  "Motor Carriers of Montana",
  "Mountain Parks Electric, Inc.",
  "Mountain Plains Library Association",
  "Mountain-Plains Museums Association",
  "Mountain Post Spouses Club",
  "Mountain States Library Association",
  "Mountain View Electric Association",
  "Mount Calvary Baptist Church Charleston, West Virginia",
  "Mount Sinai Missionary Baptist Church",
  "Mt. Hood Masonic Lodge 32",
  "Mt. Olive AME Church, Fort Myers, Florida",
  "Multnomah County Deputy Sheriffs Association",
  "Municipal Engineers Association",
  "Murida Furniture Company",
  "Museum Store Association",
  "Music Business Association",
  "Music Library Association",
  "Music Teachers National Association",
  "Muslim Community",
  "Muslim Community Association",
  "Muslim Community Association of the Bay Area",
  "Muslim Community Center, East Bay",
  "Muslim Faith",
  "Mycological Society of America",
  "Mystic Congregational Church",
  "NAACP",
  "NAACP Saginaw Branch",
  "NACE International",
  "NALS of Oregon",
  "Nassau County Library Association",
  "National 4th Infantry (IVY) Division Association",
  "National Academic Advising Association",
  "National Academy of Engineering",
  "National Academy of Social Insurance",
  "National Active and Retired Federal Employees Association",
  "National Agricultural Aviation Association",
  "National Agricultural Communicators of Tomorrow",
  "National Agri-Marketing Association",
  "National Air Traffic Controllers Association - Columbus, Ohio Chapter",
  "National Air Transportation Association",
  "National Alliance of Postal and Federal Employees",
  "National American Arab Nurses Association",
  "National Amputee Golf Association",
  "National Arab American Medical Association",
  "National Art Honor Society",
  "National Asian Pacific American Bar Association",
  "National Asian Pacific American Law Student Association",
  "National Association Directors of Nursing Administration in Long Term Care",
  "National Association for Amateur Radio",
  "National Association for Bilingual Education",
  "National Association for Campus Activities",
  "National Association for Chicana and Chicano Studies",
  "National Association for Music Education",
  "National Association for the Education of Young Children",
  "National Association for the Self-Employed",
  "National Association for Uniformed Services",
  "National Association of Agricultural Educators",
  "National Association of Biology Teachers",
  "National Association of Black Accountants",
  "National Association of Black Journalists",
  "National Association of Black Narcotic Agents",
  "National Association of Black Social Workers",
  "National Association of Composers/USA",
  "National Association of Convenience Stores",
  "National Association of Counties",
  "National Association of Deans and Directors of Schools of Social Work",
  "National Association of Educational Office Professionals",
  "National Association of Emergency Medical Technicians",
  "National Association of Executive Secretaries and Administrative Assistants",
  "National Association of Food Equipment Dealers",
  "National Association of Gifted Children",
  "National Association of Government Employees",
  "National Association of Health Services Executive",
  "National Association of Hispanic Journalists",
  "National Association of Hispanic Nurses",
  "National Association of Home Builders",
  "National Association of Insurance Women",
  "National Association of Landscape Professionals",
  "National Association of Letter Carriers",
  "National Association of Litho Clubs",
  "National Association of Minority Automobile Dealers",
  "National Association of Music Merchants",
  "National Association of Negro Business and Professional Women's Clubs",
  "National Association of Neonatal Nurses",
  "National Association of Orthopaedic Nurses",
  "National Association of Pastoral Musicians",
  "National Association of Pediatric Nurse Practitioners",
  "National Association of Physician Nurses",
  "National Association of Power Engineers",
  "National Association of Railway Business Women",
  "National Association of School Nurses",
  "National Association of School Psychologists",
  "National Association of Secondary School Principals",
  "National Association of Social Workers",
  "National Association of Student Personnel Administrators",
  "National Association of Teachers of Singing",
  "National Association of Textile Supervisors",
  "National Association of Theatre Owners of California/Nevada",
  "National Association of University Women",
  "National Association of Veterinary Technicians in America",
  "National Association of Wheat Growers",
  "National Association of Women Artists",
  "National Athletic Trainers' Association",
  "National Automatic Merchandising Association",
  "National Bar Association",
  "National Beta Clubs",
  "National Black Association for Speech-Language and Hearing",
  "National Black Law Students Association",
  "National Black MBA Association",
  "National Black Nurses' Association",
  "National Black Students' Association",
  "National Broadcasting Society",
  "National Business Association",
  "National Business Education Association",
  "National Catholic Education Association",
  "National Catholic Society of Foresters",
  "National Chief Petty Officers Association",
  "National Coal Transportation Association",
  "National Communication Association",
  "National Community Pharmacists Association",
  "National Contract Management Association",
  "National Corn Growers Association",
  "National Council for Geographic Education",
  "National Council for the Social Sciences",
  "National Council of Japanese Language Teachers",
  "National Council of Teachers of English",
  "National Council of Teachers of Mathematics",
  "National Council of Textile Organizations",
  "National Council on Family Relations",
  "National Council on Public History",
  "National Court Reporters Association",
  "National Dairy Herd Improvement Association",
  "National Defense Industrial Association",
  "National Defense Transportation Association",
  "National Dental Association",
  "National Education Association",
  "National Electric Contractors Association",
  "National Electric Manufacturers Representatives Association",
  "National Environmental Health Association",
  "National Executive Housekeepers Association",
  "National Extension Association of Family & Consumer Sciences",
  "National Farmers Union",
  "National Fastener Distributors Association",
  "National Federation of Catholic Youth Ministry",
  "National Federation of Federal Employees",
  "National Federation of Music Clubs",
  "National Federation of Press Women",
  "National Federation of the Blind",
  "National Field Archery Association",
  "National Flute Association",
  "National Foster Parent Association",
  "National Fraternal Society of the Deaf",
  "National Gay and Lesbian Task Force",
  "National Gerontological Nurses Association",
  "National Grape Cooperative",
  "National Grocers Association",
  "National Ground Water Association",
  "National Guard Association",
  "National Guard Association of Arizona",
  "National Guard Association of Arkansas",
  "National Guard Association of California",
  "National Guard Association of Connecticut",
  "National Guard Association of Georgia",
  "National Guard Association of Illinois",
  "National Guard Association of Indiana",
  "National Guard Association of Maine",
  "National Guard Association of Maryland",
  "National Guard Association of Massachusetts",
  "National Guard Association of Michigan",
  "National Guard Association of Minnesota",
  "National Guard Association of New Hampshire",
  "National Guard Association of New Jersey",
  "National Guard Association of North Dakota",
  "National Guard Association of Oklahoma",
  "National Guard Association of South Dakota",
  "National Guard Association of Tennessee",
  "National Guard Association of Texas",
  "National Guard Association of the United States",
  "National Guard Association of Utah",
  "National Guard Association of Vermont",
  "National Guard Association of Washington",
  "National Guard Officers Association of Florida",
  "National Hampshire Swine Breeders Association",
  "National Hartford Center of Gerontological Nursing Excellence",
  "National Head Start Association",
  "National Hemophilia Foundation",
  "National High School Rodeo Association",
  "National Hispanic Association of Federal Aviation Employees",
  "National Honor Society",
  "National Huguenot Society",
  "National Ice Cream Retailers Association",
  "National Independent Automobile Dealers Association",
  "National Indian Education Association",
  "National Infantry Association",
  "National Instruments",
  "National Intercollegiate Rodeo Association",
  "National Intramural Recreational Sports Association",
  "National Italian American Bar Association",
  "National Italian American Foundation",
  "National Junior Angus Association",
  "National Junior Classical League",
  "National Junior Hereford Association",
  "National Junior Swine Association",
  "National Kidney Foundation",
  "National Kitchen & Bath Association",
  "National Latino/a Law Student Association",
  "National Latino Peace Officers Association",
  "National League for Nursing",
  "National League of American Pen Women",
  "National League of Postmasters",
  "National Machine Embellishment Instructors and Artists",
  "National Medical Association",
  "National Military Fish and Wildlife Association",
  "National Native American Bar Association",
  "National Native American Law Students Association",
  "National Office Products Alliance",
  "National Opera Association",
  "National Optometric Student Association",
  "National Organization for Albinism and Hypopigmentation",
  "National Organization for Student Success",
  "National Organization of Black Law Enforcement Executives",
  "National Parking Association",
  "National Postal Mail Handlers Union",
  "National Poultry and Food Distributors Association",
  "National Propane Gas Association",
  "National Reined Cow Horse Youth Association",
  "National Reining Horse Youth Association",
  "National Retail Hardware Association",
  "National Rifle Association",
  "National Roofing Foundation",
  "National Scholastic Surfing Association",
  "National Science Teachers Association",
  "National Sculpture Society",
  "National Shellfisheries Association",
  "National Shoe Retailers Association",
  "National Shoe Travelers",
  "National Shooting Clays Association",
  "National Skeet Shooting Association",
  "National Slovak Society",
  "National Society for Histotechnology",
  "National Society of Black Engineers",
  "National Society of Collegiate Scholars",
  "National Society of High School Scholars",
  "National Society of High School Scholars Foundation",
  "National Society of Professional Engineers",
  "National Society of Professional Surveyors",
  "National Society of Public Accountants",
  "National Sorghum Producers",
  "National Speleological Society",
  "National Strength and Conditioning Association",
  "National Student Nurses' Association",
  "National Student Speech Language Hearing Association",
  "National Technical Honor Society",
  "National Television Academy",
  "National Trappers Association",
  "National Union of Hospital and Health Care Employees",
  "National Union of Public and General Employees",
  "National Urban League",
  "National Utilities Contractors Association",
  "National Utility Contractors Association",
  "National Wild Turkey Federation",
  "National Women's Studies Association",
  "National Youth Cutting Horse Association",
  "Native American Journalists Association",
  "Native American Tribe",
  "Native Daughters of the Golden West",
  "Native Sons of the Golden West",
  "Natrona County Education Association",
  "Navajo Code Talkers Association",
  "Navajo Nation",
  "Naval Cryptologic Veterans Association",
  "Naval Enlisted Reserve Association",
  "Naval Sea Cadet Corps",
  "Navy Counselors Association",
  "Navy League of the United States",
  "Navy-Marine ROTC",
  "Navy Supply Corps Foundation",
  "Navy Wives' Club of America",
  "Nazarene",
  "Nebraska Association of Fair Managers",
  "Nebraska Corn Growers Association",
  "Nebraska Farm Bureau",
  "Nebraska Grain Sorghum Producers Association",
  "Nebraska Grocery Industry Association",
  "Nebraska High School Rodeo Association",
  "Nebraska Hospital Association",
  "Nebraska Junior Chamber",
  "Nebraska League for Nursing",
  "Nebraska Library Association",
  "Nebraska Nurse Practitioners",
  "Nebraska Nurses Association",
  "Nebraska Occupational Therapy Association",
  "Nebraska Petroleum Marketers and Convenience Store Association",
  "Nebraska Quarter Horse Association",
  "Nebraska School Librarians Association",
  "Nebraska State Athletic Administrators Association",
  "Nebraska State Athletic Trainers' Association",
  "Nebraska State Business Education Association",
  "Nebraska Veterinary Medical Association",
  "Neighbors of Woodcraft",
  "Nevada Bow Hunters Association",
  "Nevada Farm Bureau Federation",
  "Nevada Library Association",
  "Nevada State Firefighters Association",
  "Nevada State High School Rodeo Association",
  "Nevada Telecommunications Association",
  "Nevada Trappers Association",
  "New Cumberland First Presbyterian Church",
  "New England Archivists",
  "New England Association of Circulation Executives",
  "New England Dressage Association",
  "New England Fastener Distributors Association",
  "New England Hemophilia Association",
  "New England Horsemen's Benevolent Protective Association",
  "New England Inns and Resorts Association",
  "New England Library Association",
  "New England Morgan Horse Association",
  "New England Newspaper Advertising Executives Association",
  "New England PGA Junior Golf Tour",
  "New England Regional Black Nurses Association",
  "New England Regional Council of Carpenters",
  "New England Sheep and Wool Growers Association",
  "New England Water Works Association",
  "New Hampshire Association of Broadcasters",
  "New Hampshire Golf Course Superintendents Association",
  "New Hampshire Grocers Association",
  "New Hampshire High Technology Council",
  "New Hampshire Landscape Association",
  "New Hampshire Land Surveyors Association",
  "New Hampshire Library Association",
  "New Hampshire National Guard Enlisted Association",
  "New Hampshire Nurses Association",
  "New Hampshire Police Association",
  "New Hampshire Retail Lumber Association",
  "New Hampshire Road Agents Association",
  "New Hampshire School Library Media Association",
  "New Hampshire School Nurses' Association",
  "New Hampshire Sheep and Wool Growers' Association",
  "New Hampshire Troopers Association",
  "New Hampshire Veterinary Technician Association",
  "New Hampshire Water Pollution Control Association",
  "New Hampshire Women's Golf Association",
  "New Jersey Asphalt Pavement Association",
  "New Jersey Association of Realtors",
  "New Jersey Association of School Librarians",
  "New Jersey Building Materials Dealers Association",
  "New Jersey Classical Association",
  "New Jersey Environmental Health Association",
  "New Jersey Farm Bureau",
  "New Jersey League for Nursing",
  "New Jersey Library Association",
  "New Jersey Nursing Students",
  "New Jersey Professional Horsemen's Association",
  "New Jersey School Nutrition Association",
  "New Jersey Special Investigators Association",
  "New Jersey State Nurses Association",
  "New Jersey State Society of Physician Assistants",
  "New Jersey Utilities Association",
  "New Mexico Academy of Nutrition and Dietetics",
  "New Mexico Association for Health, Physical Education, Recreation and Dance",
  "New Mexico Cattle Growers Association",
  "New Mexico Enlisted Association",
  "New Mexico High School Coaches Association",
  "New Mexico Library Association",
  "New Mexico Mayflower Society",
  "New Mexico National Guard Officers Association",
  "New Mexico Occupational Therapy Association",
  "New Mexico Recreation and Park Association",
  "New Morgan Hill Baptist Church in Candler, North Carolina",
  "New North Street AME Church in Springfield, Ohio",
  "Newton Instruments",
  "New York Association for Pupil Transportation",
  "New York Black Librarians' Caucus",
  "New York Classical Club",
  "New York Farm Bureau",
  "New York Health Information Management Association",
  "New York Library Association",
  "New York Occupational Therapy Association",
  "New York Organization of Nurse Executives and Leaders",
  "New York Press Association",
  "New York Region Management Association",
  "New York School Nutrition Association",
  "New York State Amateur Hockey Association",
  "New York State Association for Health, Physical Education, Recreation and Dance",
  "New York State Association of Educational Office Professionals",
  "New York State Association of Electrical Contractors",
  "New York State Association of Family and Consumer Science Educators",
  "New York State Association of Family and Consumer Sciences",
  "New York State Association of Foreign Language Teachers",
  "New York State Association of School Nurses",
  "New York State Athletic Trainers' Association",
  "New York State Bar Association",
  "New York State Golf Association",
  "New York State Government Finance Officers Association",
  "New York State Horse Council",
  "New York State Hospitality & Tourism Association",
  "New York State Library Assistants' Association",
  "New York State PeriAnesthesia Nurses Association",
  "New York State Professional Fire Fighters Association",
  "New York State Public Employees Federation",
  "New York State Society of Physician Assistants",
  "New York State Trappers Association",
  "New York State Turfgrass Association",
  "New York Water Environment Association",
  "New York Women in Communications",
  "NexThermal",
  "Niantic's Black Point Beach Club Association",
  "NIBA-The Belting Association",
  "Nicholas County Law Enforcement",
  "Ninety-Nines",
  "Nisei Veterans Committee",
  "NLGJA: The Association of LGBTQ Journalists",
  "No Bull Sports",
  "Non-Commissioned Officers Association",
  "Non-Commissioned Officers Association Auxiliary",
  "Nordic Ski Association of Anchorage",
  "Nordmanns-Forbundet",
  "North American Conference on British Studies",
  "North American Gamebird Association",
  "North American Judges and Stewards Association",
  "North American Membrane Society",
  "North American Patristic Society",
  "North American Serials Interest Group",
  "North American Society for the Sociology of Sport",
  "North American Society for Trenchless Technology",
  "North American Wholesale Lumber Association",
  "North Bay Coast Guard Spouses Club",
  "North Carolina Academy of Physician Assistants",
  "North Carolina Academy of Science",
  "North Carolina Alliance for Athletics, Health, Physical Education, Recreation, Dance, and Sports Management",
  "North Carolina Association of Agricultural Fairs",
  "North Carolina Association of Broadcasters",
  "North Carolina Association of Educational Office Professionals",
  "North Carolina Association of Educators",
  "North Carolina Association of Teacher Assistants",
  "North Carolina Athletic Trainers' Association",
  "North Carolina Bar Association",
  "North Carolina Business Education Association",
  "North Carolina Child Support Council",
  "North Carolina Farm Bureau",
  "North Carolina Highway Patrol",
  "North Carolina Junior Angus Association",
  "North Carolina National Guard Association",
  "North Carolina Nursery and Landscape Association",
  "North Carolina Nurses Association",
  "North Carolina Occupational Therapy Association",
  "North Carolina Pest Management Association",
  "North Carolina Petroleum and Convenience Marketers",
  "North Carolina Public Health Association",
  "North Carolina Retail Merchants Association",
  "North Carolina School Library Media Association",
  "North Carolina Troopers Association",
  "North Carolina Trucking Association",
  "North Carolina Vietnam Veterans",
  "North Country Spouses Club",
  "North Dakota Corn Growers Association",
  "North Dakota CPA Society",
  "North Dakota Farm Bureau",
  "North Dakota Farmers Union",
  "North Dakota High School Coaches Association",
  "North Dakota Junior Angus Association",
  "North Dakota Library Association",
  "North Dakota Motor Carriers Association",
  "North Dakota National Guard Enlisted Association",
  "North Dakota Society of CPAs",
  "North Dakota Solid Waste and Recycling Association",
  "North Dakota Stockmen's Association",
  "North Dakota United",
  "Northeast Early College High School Football Team",
  "Northeastern Association of Forensic Scientists",
  "Northeastern Golf Course Superintendents Association",
  "Northeastern Loggers' Association",
  "Northeastern Young Lumber Execs",
  "Northeast Illinois District Council of Carpenters",
  "Northeast Ohio Nurse Practitioners",
  "North East Roofing Contractors Association",
  "Northern California Association of Law Libraries",
  "Northern California Carpenters Regional Council",
  "Northern California Turf and Landscape Council",
  "Northern Minnesota Builders' Association",
  "Northern Ohio Hemophilia Association",
  "Northminster Presbyterian Church",
  "North Plains Electric Cooperative",
  "Northrop Rice Foundation",
  "Northwest Archivists",
  "Northwest Automatic Vending Association",
  "Northwest Danish Association",
  "Northwestern Illinois Building Trades and Construction Council",
  "Northwestern Illinois Golf Course Superintendents Association",
  "Northwestern Pennsylvania Golf Course Superintendents Association",
  "Northwest Federal Employees Association",
  "Northwest Fisheries Association",
  "Northwest Georgia Transportation Club",
  "Norway-America Association",
  "Norwegian Researchers and Teachers of North America",
  "Novant Health",
  "NROTC",
  "Nueces County Council",
  "Nurse Educators of Illinois",
  "Nurse Practitioner Association of South Dakota",
  "Nurse Practitioners of Idaho",
  "Nurses Organization of Veterans Affairs",
  "Oahu Council of Filipino Catholic Clubs",
  "Oakland Interfaith Youth Gospel Choir",
  "OCA Asian Pacific American Advocates",
  "Occupational Therapy Association of California",
  "Occupational Therapy Association of Colorado",
  "Occupational Therapy Association of Hawaii",
  "Occupational Therapy Association of Oregon",
  "Office and Professional Employees International Union",
  "Office Furniture Dealers Alliance",
  "Officers Association",
  "Ogle County Fire Department",
  "Ohio Academy of Family Physicians",
  "Ohio Association for Career and Technical Education",
  "Ohio Association for Health, Physical Education, Recreation and Dance",
  "Ohio Association of Advanced Practice Nurses",
  "Ohio Association of Physician Assistants",
  "Ohio Association of Public-School Employees",
  "Ohio Association of School Nurses",
  "Ohio Business Teachers Association",
  "Ohio Cattlemen's Association",
  "Ohio Civil Service Employees Association",
  "Ohio Classical Conference",
  "Ohio Corn and Wheat Growers Association",
  "Ohio County Sheriff's Office",
  "Ohio Directors of Nursing Administration in Long Term Care",
  "Ohio Educational Library Media Association",
  "Ohio Education Association",
  "Ohio Environmental Health Association",
  "Ohio Farm Bureau Federation",
  "Ohio Government Finance Officers Association",
  "Ohio Harness Horsemen's Association",
  "Ohio High School Baseball Coaches Association",
  "Ohio High School Basketball Coaches Association",
  "Ohio High School Rodeo Association",
  "Ohio Interscholastic Athletic Administrators Association",
  "Ohio Landscape Association",
  "Ohio Marketing Education Association",
  "Ohio Mission District of the North American Lutheran Church",
  "Ohio National Guard Association",
  "Ohio National Guard Enlisted Association and Auxiliary",
  "Ohio Nursery & Landscape Association",
  "Ohio Nurses Association",
  "Ohio Nutrition Council",
  "Ohio Planning Conference",
  "Ohio Pork Council",
  "Ohio Rubber Group",
  "Ohio School Psychologists Association",
  "Ohio Sheep Improvement Association",
  "Ohio Society of CPAs",
  "Ohio Society of Professional Engineers",
  "Ohio State Bar Association",
  "Oklahoma Agricultural Education Teachers Association",
  "Oklahoma Athletic Trainers' Association",
  "Oklahoma Bankers Association",
  "Oklahoma Cattlemen's/Junior Cattlemen's/CattleWomen's Association",
  "Oklahoma Correctional Association",
  "Oklahoma Farm Bureau",
  "Oklahoma Golf Course Superintendents Association",
  "Oklahoma Grocers Association",
  "Oklahoma Indian Student Honor Society",
  "Oklahoma Library Association",
  "Oklahoma Nurses' Association",
  "Oklahoma Occupational Therapy Association",
  "Oklahoma Recreation and Park Society",
  "Oklahoma Society of Certified Public Accountants",
  "Oklahoma Society of Land Surveyors",
  "Oklahoma State Firefighters Association",
  "Oklahoma Telephone Association",
  "Olympic Logging Conference",
  "Omega Boys Club",
  "Omega Psi Phi",
  "Oncology Nursing Society",
  "One N Ten",
  "Operating Room Nursing Council of California",
  "Optical Society of America",
  "Optimist Club",
  "Orange County Colony of Mayflower Descendants",
  "Orchards Golf Course",
  "Order of Daedalians",
  "Order of DeMolay",
  "Order of Omega",
  "Order of the Amaranth",
  "Order of the Eastern Star",
  "Order of the Sons of Hermann",
  "Order Sons of Italy in America",
  "Oregon Association Chiefs of Police",
  "Oregon Association of Nurseries",
  "Oregon Association of Secondary School Administrators",
  "Oregon Business Education Association",
  "Oregon Cattlemen's Association",
  "Oregon Concrete and Aggregate Producers Association",
  "Oregon Education Association",
  "Oregon Farm Bureau",
  "Oregon Feed and Grain Association",
  "Oregon Golf Course Superintendents Association",
  "Oregon Hunter Jumper Association",
  "Oregon Library Association",
  "Oregon National Guard Association",
  "Oregon Nurses Association",
  "Oregon Pilots Association",
  "Oregon Quarter Horse Association",
  "Oregon Refuse and Recycling Association",
  "Oregon School Employees Association",
  "Oregon Seed Association",
  "Oregon State Fiscal Association",
  "Oregon State Grange",
  "Oregon State Personnel Management Association",
  "Oregon State Plumbing-Heating-Cooling Contractors Association",
  "Oregon Telecommunications Association",
  "Oregon Trucking Association",
  "Oregon Wheat Growers League",
  "Organization for Associate Degree Nursing",
  "Organization of American Historians",
  "Organization of Black Aerospace Professionals",
  "Organization of Maine Nurse Executives/Nursing Leaders of Maine",
  "Orthodox",
  "Orthodox Church",
  "Orthodox Society of America",
  "Orthopaedic Research Society",
  "Orthopaedic Trauma Association",
  "Osteology Foundation",
  "Othello's Restaurant Group",
  "Ouray County Fire Department",
  "Outrigger Enterprises",
  "Outside Processors Council",
  "Oxford United Methodist Church in San Antonio, Texas",
  "Pacific and Asian Affairs Council",
  "Pacific Media Workers Guild",
  "Pacific Northwest Association of Rail Shippers",
  "Pacific Northwest Clean Water Association",
  "Pacific Northwest Grain & Feed Association",
  "Pacific Northwest Vegetable Association",
  "Pacific Water Quality Association",
  "Package Pavement Company",
  "Pagan",
  "Paleontological Research Institution",
  "Paleontological Society",
  "Palestinian American Research Center",
  "Palladin Precision Products",
  "Palm Beach County Library Association",
  "Palm Beach Kennel Club",
  "Palomar Amateur Radio Club",
  "Palomino Horse Breeders of America",
  "Palos Verdes Home Association",
  "Pan-American Association of Ophthalmology",
  "Pancretan Association of America",
  "Pan Pacific Pathologists",
  "Pan-Rhodian Society of America",
  "Paper, Allied-Industrial, Chemical and Energy Workers International Union",
  "Paralyzed Veterans of America",
  "Parent Eligible for MOAA Membership",
  "Parents Without Partners",
  "Par Hawaii Refining",
  "Parish of St. Elizabeth Church, Grove Place, Pleasant Hills, Pennsylvania",
  "Parkinson Study Group",
  "P. Buckley Moss Society",
  "Peace Officers Research Association of California",
  "Pecatonica High School",
  "Pediatric Endocrinology Nursing Society",
  "Pekin Riding Club",
  "Peninsula Regent",
  "Pennfield High School",
  "Pennsylvania Academy of Nutrition and Dietetics",
  "Pennsylvania Association of Educational Office Professionals",
  "Pennsylvania Association of Nurse Anesthetists",
  "Pennsylvania Association of School Nurses and Practitioners",
  "Pennsylvania Athletic Trainers' Society",
  "Pennsylvania Automotive Recycling Trade Society",
  "Pennsylvania Bar Association",
  "Pennsylvania Business Education Association",
  "Pennsylvania Cattlemen's Association/Junior Cattlemen's Association",
  "Pennsylvania Equine Council",
  "Pennsylvania Federation of Republican Women",
  "Pennsylvania Holstein Association",
  "Pennsylvania Institute of Certified Public Accountants",
  "Pennsylvania Junior Holstein Association",
  "Pennsylvania Library Association",
  "Pennsylvania Medical Society",
  "Pennsylvania Morgan Horse Club",
  "Pennsylvania Occupational Therapy Association",
  "Pennsylvania Osteopathic Medical Association",
  "Pennsylvania Rural Electric Association",
  "Pennsylvania Society of Physician Assistants",
  "Pennsylvania State Association for Health, Physical Education, Recreation and Dance",
  "Pennsylvania State Education Association",
  "Pennsylvania State Nurses Association",
  "Penn-Trafford High School Band",
  "Penn-Trafford High School Chorus",
  "Pentecostal",
  "People of Praise",
  "People of Praise Portland Branch",
  "People of Praise Vancouver Branch",
  "People of Praise Washington Branch",
  "People to People International",
  "Percussion Arts Society",
  "PeriAnesthesia Nurses Association of California",
  "Perishable Foods Council of Northern California",
  "Pesticide Applicators Professional Association",
  "Petroleum Services Association of Canada",
  "Phantom Regiment",
  "Phi Alpha Theta",
  "Phi Delta Theta Fraternity - Pennsylvania Delta Chapter",
  "Philippine-American Association of Lorain County",
  "Philippine Nurses Association of America",
  "Philippine Nurses Association of Georgia",
  "Philippine Nurses Association of Metropolitan D.C.",
  "Philippine Nurses Association of New Jersey",
  "Philippine Nurses Association of Northern California",
  "Philippine Nurses Association of Southern California",
  "Phillips Resources",
  "Phi Sigma Kappa",
  "Phi Theta Kappa",
  "Phoenix Public Library",
  "Phycological Society of America",
  "Physician Assistant Academy of Vermont",
  "Pi Kappa Phi Theta Iota WDS Chapter",
  "Pikes Peak Lodging Association",
  "Pioneers Volunteer",
  "Pittsburgh Young Professionals",
  "Pizza Hut of Arizona",
  "Plantmix Asphalt Industry of Kentucky",
  "Plastic Surgery Research Council",
  "Plumbing-Heating-Cooling Contractors of Massachusetts",
  "Plumbing-Heating-Cooling Contractors of Nebraska",
  "Plumbing-Heating-Cooling Contractors of North Carolina",
  "Pocono Turfgrass Association",
  "Poetry Society of America",
  "Poetry Society of South Carolina",
  "Police and Firemen's Insurance Association",
  "Police Department",
  "Polish American Board of Education",
  "Polish American Club of North Jersey",
  "Polish American Congress",
  "Polish American Cultural Institute of Minnesota",
  "Polish American Engineers Association",
  "Polish Beneficial Association",
  "Polish Falcons of America",
  "Polish National Alliance",
  "Polish National Union of America",
  "Polish Roman Catholic Union of America",
  "Polish Union of America",
  "Polish Union of U.S.A.",
  "Polish University Club of Los Angeles",
  "Polish Women's Alliance",
  "Polymer Enterprises",
  "Pony of the Americas Club",
  "Pope Bragg Spouses' Association",
  "Portuguese American Cultural Center",
  "Portuguese American Leadership Council of the United States",
  "Portuguese Continental Union",
  "Portuguese Fraternal Society of America",
  "Potter County Fire Department",
  "Poudre Valley Rural Electric Association, Inc.",
  "Poultry Science Association",
  "Prairie Farms Dairy",
  "Premier Farm Credit",
  "Premium",
  "Presbyterian",
  "Presbyterian Church",
  "Preventive Cardiovascular Nurses Association",
  "Printing Industry Midwest",
  "Professional Association of Georgia Educators",
  "Professional Beauty Association",
  "Professional Convention Management Association",
  "Professional Engineers in California Government",
  "Professional Fire Fighters",
  "Professional Firefighters of Idaho",
  "Professional Fire Fighters of Massachusetts",
  "Professional Fire Fighters of Nevada",
  "Professional Golfers' Association",
  "Professional Horseman's Association",
  "Professional Independent Agents Association of Ohio",
  "Professional Land Surveyors of Ohio",
  "Professional Land Surveyors of Oregon",
  "Project Management Institute",
  "Pronto Auto Service Centers",
  "Propane Education and Research Council",
  "Propeller Club of the United States",
  "Prospanica",
  "PRO-TEC Coating Company",
  "Protein Society",
  "Protestant Church",
  "Protestant Faith",
  "Protestant Minister in Hawaii",
  "Providence Association of Ukrainian Catholics",
  "PTA",
  "Public Agency Risk Managers Association",
  "Public Health Nurses Association of Colorado",
  "Public Relations Student Society of America",
  "Public Safety Officer",
  "Public School Employees of Washington",
  "Purdue AAE",
  "Quail Creek Golf and Country Club",
  "Quaker",
  "Quality Life Center",
  "Quantico Officers' Spouses' Organization",
  "Quarter Horse Racing Association of Indiana",
  "Queen's Medical Center",
  "Querencia",
  "Quick Auto",
  "Quill and Scroll",
  "Radiological Society of North America",
  "Railway Engineering-Maintenance Suppliers Association",
  "Railway Supply Institute",
  "Raleigh County Public Schools Bus Driver",
  "Raleigh County Public Schools Mechanic",
  "Rancho California Arabian Horse Association",
  "Randall County Fire Department",
  "Randolph Officers' Spouses' Club",
  "Raptor Research Foundation",
  "RBC Royal Bank",
  "Red Angus Association of America/Junior Red Angus Association",
  "Redding Electrical Utility",
  "Redding Rodeo Association",
  "Red Dragon Players",
  "Red River Valley Fighter Pilots Association",
  "Redstone",
  "Redstone Arsenal Military and Civilians' Club",
  "Red & White Dairy Cattle Association",
  "Red Wing Properties",
  "Redwood Empire Chinese Association",
  "REFORMA",
  "Reformed",
  "Religious Research Association",
  "Renaissance Society of America",
  "Rent-A-Center",
  "Republican Party",
  "Reserve Officers Association",
  "Retail Industry",
  "Retail Lumber Dealers Association of Maine",
  "Retail, Wholesale and Department Store Union",
  "Retired Employees of San Diego County",
  "Retired Enlisted Association",
  "Rhode Island Association for Health, Physical Education, Recreation and Dance",
  "Rhode Island Association of Chinese Americans",
  "Rhode Island Athletic Trainer's Association",
  "Rhode Island Lumber and Building Materials Dealers Association",
  "R.H. White Companies",
  "Richardson Spouses' Club",
  "Rio Blanco County Fire Department",
  "Risk Management Association",
  "Riverdale High School",
  "River Oaks Country Club",
  "R.J. Reynolds Tobacco Company",
  "R+L Carriers",
  "Rochester Area School Librarians",
  "Rock Island Arsenal Welcome Club",
  "Rockline Industries",
  "Rocky Mountain Agribusiness Association",
  "Rocky Mountain Farmers Union",
  "Rocky Mountain Water Environment Association",
  "Rodeo Historical Society",
  "Roman Catholic",
  "Roman Catholic Church",
  "Roseburg Forest Products",
  "Rotary",
  "ROTC",
  "Rotmans Furniture Company",
  "Royal Canadian College of Organists",
  "Royal Carting Service",
  "Royal Neighbors of America",
  "Royal Oaks Country Club",
  "Rural Water Association of Utah",
  "Russian Brotherhood Organization",
  "Ruth Jackson Orthopaedic Society",
  "Sacramento County Alliance of Law Enforcement",
  "Sacramento County Farm Bureau",
  "Sacramento Valley Association of Building Officials",
  "Saddlerock Evangelical Presbyterian Church",
  "Saginaw County 4-H",
  "Saginaw County Fair",
  "Saginaw County Sports Hall of Fame",
  "Saginaw Education Association",
  "Saginaw Geriatrics Home",
  "Saginaw Township Business Association",
  "Saint Florian Church in Mount Pleasant, Pennsylvania",
  "Salina Country Club",
  "San Antonio Chapter of the Associated General Contractors",
  "San Antonio Music Teachers Association",
  "San Benito County CattleWomen",
  "San Diego Area Law Libraries",
  "San Diego County Court Employees Association",
  "San Diego County Deputy Sheriffs' Association",
  "San Diego County Junior Golf Association",
  "San Diego Education Association",
  "San Fernando Valley Japanese American Community Center",
  "San Francisco Intellectual Property Law Association",
  "Sangre de Cristo Electric Association",
  "Sanibel City",
  "Sanibel Community Church",
  "San Isabel Electric Association, Inc.",
  "San Joaquin Farm Bureau",
  "San Luis Obispo County Farm Bureau",
  "San Luis Valley Rural Electric Cooperative, Inc.",
  "San Mateo County Farm Bureau",
  "San Miguel Power Association",
  "San Ramon Valley Islamic Center",
  "Santa Barbara County Deputy Sheriffs' Association",
  "Santa Clara County Speech-Language Hearing Association",
  "Santa Cruz County Farm Bureau",
  "Sarrat Association of Hawaii",
  "Scarsdale Acres",
  "School Library Media Specialists of Southeastern New York",
  "School Nurse Association of North Carolina",
  "School Nurse Organization of Washington",
  "School Nutrition Association",
  "School Nutrition Association of Iowa",
  "School Nutrition Association of North Carolina",
  "School Nutrition Association of Ohio",
  "School Nutrition Association of South Carolina",
  "School Nutrition Association of Virginia",
  "School Nutrition Association of Wisconsin",
  "Scottish Rite",
  "Screen Actors Guild-American Federation of Television and Radio Artists",
  "Seacoast Church",
  "Seafarers International Union",
  "Seaplane Pilots Association",
  "Second (Indianhead) Division Association",
  "SECURA's Non-Executive Associates",
  "Seed Division of the Texas Department of Agriculture",
  "Semiconductor Environmental Safety and Health Association",
  "Serbian Orthodox Church",
  "Serb National Federation",
  "Sertoma International",
  "Service Employees International Union",
  "Seventh Day Adventist",
  "Seymour Johnson Officer and Civilian Spouses' Club",
  "Shakespeare Association of America",
  "Shasta County Cattlemen's and Cattlewomen's Associations",
  "Sheet Metal and Air Conditioning Contractors' National Association",
  "Sheet Metal Workers' International Association Local 124",
  "Sheet Metal Workers Local Union 124 Member",
  "Sheriff's Office",
  "Sickle Cell Disease Association of America",
  "Sierra Nevada Golf Course Superintendents Association",
  "Sigma Delta Tau",
  "Sikh",
  "Silver Eagle Distributors",
  "Silver-Line Plastics Corporation",
  "Silver Wings",
  "Sinaitenians of Oahu",
  "Sioux Falls Kiwanis Club",
  "Sixteenth Century Society and Conference",
  "Sixth Marine Division Association",
  "SkillsUSA",
  "Skyline Country Club of Southern Arizona",
  "Slovak Catholic Sokol",
  "Slovene National Benefit Society",
  "Slovenian Union of America",
  "Smaller Manufacturers Association Member Companies",
  "Smithwood Baptist Church in Knoxville, Tennessee",
  "SMS",
  "Snowmobile North Dakota",
  "Soaring Society of America",
  "Sociedade Portuguesa Rainha Santa Isabel",
  "Society Farsarotul",
  "Society for Academic Emergency Medicine",
  "Society for Adolescent Medicine",
  "Society for Advancement of Chicanos and Native Americans in Science",
  "Society for American Music",
  "Society for Biblical Literature",
  "Society for Cinema Studies",
  "Society for Classical Studies",
  "Society for Developmental Biology",
  "Society for Economic Botany",
  "Society for Electro-Acoustic Music in the United States",
  "Society for Ethnomusicology",
  "Society for Glycobiology",
  "Society for Historians of American Foreign Relations",
  "Society for Human Resource Management",
  "Society for Industrial and Applied Mathematics",
  "Society for Integrative and Comparative Biology",
  "Society for Maternal Fetal Medicine",
  "Society for Military History",
  "Society for Mining, Metallurgy, and Exploration",
  "Society for Music Theory",
  "Society for Neuroscience",
  "Society for Pediatric Dermatology",
  "Society for Pediatric Research",
  "Society for Personality and Social Psychology",
  "Society for Protective Coatings",
  "Society for Public Health Education",
  "Society for Range Management",
  "Society for Research in Child Development",
  "Society for Technical Communication",
  "Society for the Advancement of Material and Process Engineering",
  "Society for the Advancement of Scandinavian Study",
  "Society for the Preservation of Natural History Collections",
  "Society for the Psychological Study of Social Issues",
  "Society for the Scientific Study of Sexuality",
  "Society for the Study of Amphibians and Reptiles",
  "Society for the Study of Early Modern Women",
  "Society for the Study of Reproduction",
  "Society for the Study of Social Problems",
  "Society for Vascular Nursing",
  "Society for Vascular Surgery",
  "Society of Actuaries",
  "Society of American Archivists",
  "Society of American Foresters",
  "Society of American Indian Government Employees",
  "Society of American Military Engineers",
  "Society of Architectural Historians",
  "Society of Automotive Engineers",
  "Society of Biblical Literature",
  "Society of Biological Psychiatry",
  "Society of Black Academic Surgeons",
  "Society of Broadcast Engineers",
  "Society of Cable Telecommunications Engineers",
  "Society of California Archivists",
  "Society of Chairmen of Academic Radiology Departments",
  "Society of Children's Book Writers and Illustrators",
  "Society of Composers",
  "Society of Critical Care Medicine",
  "Society of Dance History Scholars",
  "Society of Diagnostic Medical Sonography",
  "Society of Economic Geologists",
  "Society of Emergency Medicine Physician Assistants",
  "Society of Environmental Toxicology and Chemistry",
  "Society of Ethnobiology",
  "Society of Fire Protection Engineers",
  "Society of Flight Test Engineers",
  "Society of Gastroenterology and Associates",
  "Society of Gynecologic Oncology",
  "Society of Health and Physical Educators",
  "Society of Health Physical Education of Arkansas",
  "Society of Hispanic Professional Engineers",
  "Society of Louisiana Certified Public Accountants",
  "Society of Manufacturing Engineers",
  "Society of Mayflower Descendants",
  "Society of Mexican American Engineers and Scientists",
  "Society of Motion Picture and Television Engineers",
  "Society of Naval Architects and Marine Engineers",
  "Society of Nuclear Medicine and Molecular Imaging",
  "Society of Otorhinolaryngology and Head-Neck Nurses",
  "Society of Pediatric Nurses",
  "Society of Pediatric Psychology",
  "Society of Petroleum Engineers",
  "Society of Physician Assistants in Otorhinolaryngology/Head Neck Surgery",
  "Society of Physics Students",
  "Society of Plastics Engineers",
  "Society of Professional Journalists",
  "Society of Rheology",
  "Society of Satellite Professionals International",
  "Society of Southwest Archivists",
  "Society of Surgical Oncology",
  "Society of Systematic Biologists",
  "Society of the 3rd Infantry Division",
  "Society of the Descendants of the Signers of the Declaration of Independence",
  "Society of Toxicology",
  "Society of Urologic Nurses and Associates",
  "Society of Vertebrate Paleontology",
  "Society of Wetland Scientists",
  "Society of Women Engineers",
  "Sociologists for Women in Society",
  "Soil and Water Conservation Society",
  "Soil Science Society of America",
  "SOKOL USA",
  "Solid Waste Association of North America",
  "Sons and Daughters, Pearl Harbor Survivors",
  "Sons of Confederate Veterans",
  "Sons of Italy",
  "Sons of Italy Lodge 2456",
  "Sons of Norway",
  "Sons of Pericles",
  "Sons of the American Legion",
  "Sons of Union Veterans of the Civil War",
  "Soo Yuen Benevolent Society",
  "Sorority",
  "South African Association of University Women",
  "South Asian Bar Association",
  "South Bay Chinese Service Club",
  "South Bay Islamic Association",
  "South Bay Islamic Center",
  "South Carolina Association of Educational Office Professionals",
  "South Carolina Association of School Librarians",
  "South Carolina Athletic Trainers' Association",
  "South Carolina Cattlemen's Association",
  "South Carolina Early Childhood Association",
  "South Carolina Electronic Security Association",
  "South Carolina Farm Bureau",
  "South Carolina Law Enforcement Officers Association",
  "South Carolina Public Health Association",
  "South Carolina State Employees Association",
  "South Central Modern Language Association",
  "South Dakota Automobile Dealers Association",
  "South Dakota Cattlemen's Association",
  "South Dakota Education Association",
  "South Dakota Farm Bureau",
  "South Dakota Farmers Union",
  "South Dakota High School Rodeo Association",
  "South Dakota Library Association",
  "South Dakota National Guard Enlisted Association and Auxiliary",
  "South Dakota Nurses Association",
  "South Dakota Occupational Therapy Association",
  "South Dakota Society for Technology in Education",
  "South Dakota Stockgrowers Association",
  "South Dakota Telecommunications Association",
  "South Dakota Trappers Association",
  "Southeast Brangus Breeders Association",
  "Southeast Colorado Power Association",
  "Southeastern American Society for Eighteenth Century Studies",
  "Southeastern Beefmaster Breeders Association",
  "Southeastern Grain & Feed Association",
  "Southeastern Museums Conference",
  "Southern Association for Women Historians",
  "Southern Baptist",
  "Southern California Association of Law Librarians",
  "Southern California Botanists",
  "Southern California Golf Association",
  "Southern Connecticut Black Nurses Association",
  "Southern Early Childhood Association",
  "Southern Historical Association",
  "Southern Illinois Golf Course Superintendents Association",
  "Southern Interscholastic Press Association",
  "Southern Nevada Golf Course Superintendents Association",
  "Southern New England Law Librarians Association",
  "Southern New England Saddlebred Association",
  "Southern Nursing Research Society",
  "Southern Ohio Synod in Westerville, Ohio",
  "Southern States Correctional Association",
  "Southern Wholesalers Association",
  "South Florida Manufacturers Association",
  "South Texas Golf Course Superintendents Association",
  "Southwestern Association of Law Libraries",
  "Southwest Florida Junior Golf Association",
  "Southwest Missouri Cattlemen's Association",
  "Spanish Honor Society",
  "Specialized Carriers & Rigging Association",
  "Special Libraries Association",
  "Specialty Advertising Association of California",
  "Specialty Equipment Market Association",
  "Speech-Language-Hearing Association of Western New York",
  "SPIE, The International Society for Optics and Photonics",
  "Spike Box Ranch",
  "Spina Bifida Association of America",
  "Spina Bifida Association of Iowa",
  "SPJST",
  "Splendido at Rancho Vistos, Arizona",
  "Splendido at Rancho Vistoso, Arizona",
  "Sports Turf Managers Association",
  "Spouses' Club",
  "Spouses' Club of Fort Eustis",
  "Springfield Middle School",
  "Springfield Newspapers' 25 Year Club",
  "Springfield Police Division",
  "Springfield Regional School of Nursing",
  "Spring Run Country Club",
  "Stage Directors and Choreographers Society",
  "Standard Sales Company",
  "St. Andrews Catholic Church",
  "St. Andrew's Society",
  "St. Andrew's Society of Maine",
  "St. Andrew's Society of Vermont",
  "Stanislaus County Peace Officers Association",
  "State Bar of Texas",
  "State College of Florida",
  "State Employees Association of North Carolina",
  "State Farm",
  "State of Maryland Literacy Association",
  "State of Texas",
  "State of Texas Peace Officer",
  "State of Texas Professional Firefighter",
  "State of West Virginia",
  "State Police Department",
  "State Propane Gas Association",
  "State University of New York Librarians Association",
  "Statistics Society of Canada",
  "St. Dominic Catholic Church in Saginaw, Michigan",
  "Stephenson County Fire Department",
  "St. Francis Home",
  "St. Gabriel the Archangel Parish in Upton, Massachusetts",
  "St. George Orthodox Cathedral in Charleston, West Virginia",
  "St. Joseph's Filipino Catholic Club",
  "St. Luke the Evangelist Church in Westborough, Massachusetts",
  "St. Luke United Methodist Church in Lincoln, Nebraska",
  "St. Mark Lutheran Church",
  "St. Martin's Episcopal Church",
  "St. Mary Byzantine Catholic Church - Westmoreland County, Pennsylvania",
  "St. Mary's Assumption Albanian Orthodox Church in Worcester, Massachusetts",
  "St. Mary's Church in Pahokee, Florida",
  "Stormville Trucking",
  "Sto-Rox High School Football Team",
  "St. Patrick - St. Anthony Catholic Parish Church",
  "St. Paul's United Methodist Church - Allison Park, Pennsylvania",
  "Structural Engineers Association of California",
  "St. Stanislaus Knights of Columbus",
  "St. Stanislaus Parish in Pleasant Valley, New York",
  "Student American Black Chiropractic Association",
  "Student American Chiropractic Association",
  "Student American Dental Assistants Association",
  "Student American Dental Hygienists' Association",
  "Student Education Association of Nebraska",
  "Student Government",
  "Student National Medical Association",
  "Student National Pharmaceutical Association",
  "Student Nurses Association of Illinois",
  "Student Nurses Association of Pennsylvania",
  "Student Osteopathic Medical Association",
  "Student Professional Association of Georgia Educators",
  "Students for the Exploration and Development of Space",
  "Suffolk County Jack & Jill Chapter of Long Island, NY",
  "Suffolk County Library Association",
  "Sun Valley Manor",
  "Supreme Council of the Royal Arcanum",
  "Supreme Emblem Club of the United States",
  "Surface Navy Association",
  "Surfrider Foundation",
  "Sweet Adelines International",
  "SWE Homes",
  "SWE Homes Contractor",
  "Swift Transportation",
  "SYNNEX Corporation",
  "Taco Mayo Franchise Systems",
  "Tag and Label Manufacturers Institute",
  "Tall Clubs International",
  "TAPPI",
  "TD Canada Trust",
  "Teachers of English to Speakers of Other Languages",
  "Teammates Mentoring Program",
  "Team One Credit Union",
  "Teamsters Canada Rail Conference",
  "Technical Women's Organization",
  "Technology Student Association",
  "TeenWorks",
  "Temple Emanuel",
  "Tendercare Saginaw",
  "Tennessee Association for Family and Community Education",
  "Tennessee Association of Plumbing-Heating-Cooling Contractors",
  "Tennessee Association of School Librarians",
  "Tennessee Cattlemen's Association/ Cattlemen's Youth Association",
  "Tennessee Education Association/Student Tennessee Education Association",
  "Tennessee Farm Bureau",
  "Tennessee Foster Adoptive Care Association",
  "Tennessee Grocers & Convenience Store Association",
  "Tennessee Library Association",
  "Tennessee Nurses' Association",
  "Tennessee Occupational Therapy Association",
  "Tennessee School Nutrition Association",
  "Tennessee Society of Professional Engineers",
  "Tennessee Trucking Association",
  "Tennessee Turfgrass Association",
  "Tennessee Walking Horse Breeders' and Exhibitors' Association",
  "Teratology Society",
  "Texas Academy of Physician Assistants",
  "Texas and Southwestern Cattle Raisers Association",
  "Texas Angus Association",
  "Texas Association for Bilingual Education",
  "Texas Association for Health, Physical Education Recreation and Dance",
  "Texas Association for Pupil Transportation",
  "Texas Association for School Nutrition",
  "Texas Association of Broadcasters",
  "Texas Association of Chicanos in Higher Education",
  "Texas Association of Extension Home Economists, District 1",
  "Texas Association of Future Educators",
  "Texas Association of Music Schools",
  "Texas Association of PeriAnesthesia Nurses",
  "Texas Big Game Awards",
  "Texas Business and Technology Education Association",
  "Texas Business Women",
  "Texas CattleWomen",
  "Texas Choral Directors Association",
  "Texas City Management Association",
  "Texas Classical Association",
  "Texas Computer Education Association",
  "Texas Corn Producers",
  "Texas Dental Hygienists' Association",
  "Texas Department of Transportation",
  "Texas District and County Attorneys Association",
  "Texas Educational Support Staff Association",
  "Texas Environmental Health Association",
  "Texas Extension Association of Family and Consumer Science",
  "Texas Farm Bureau",
  "Texas Future Teachers Association",
  "Texas Gulf Surfing Association",
  "Texas High School Rodeo Association",
  "Texas Junior Angus Association",
  "Texas Junior Hereford Association",
  "Texas Junior Polled Hereford Association",
  "Texas Junior Red Angus Association",
  "Texas Library Association",
  "Texas Medical Association",
  "Texas Music Educators Association",
  "Texas Nurse Practitioners",
  "Texas Nursing Students Association",
  "Texas Occupational Therapy Association",
  "Texas Organization of Nurse Executives",
  "Texas Pharmacy Association",
  "Texas Public Health Association",
  "Texas Retailers Association Member",
  "Texas Retired Teachers Association",
  "Texas Rodeo Cowboy Hall of Fame",
  "Texas Rural Electric Women's Association",
  "Texas Seed Trade Association",
  "Texas Society of Certified Public Accountants",
  "Texas State Florists Association",
  "Texas Trappers and Fur Hunters Association",
  "Texas Travel Industry Association",
  "Texas Vegetation Management Association",
  "Texas Water Utilities Association",
  "Texas Women in Law Enforcement",
  "Texas Youth Rodeo Association",
  "The American Association of Nurse Attorneys",
  "The Annunciation Greek Orthodox Cathedral",
  "The CIRI Foundation",
  "The Columbian",
  "The Country Club at DC Ranch",
  "The First Tee",
  "The Los Angeles Rubber Group",
  "The Minerals, Metals and Materials Society",
  "The Obesity Society",
  "Theophilo Braga Brotherhood",
  "The Pacific Club",
  "The Providence Association",
  "The Rocks",
  "The Santaluz Club",
  "The Society for Healthcare Epidemiology of America",
  "The Spouses' Club of the Fort Sam Houston Area",
  "The Walter J. Travis Society",
  "The Wildlife Society",
  "The Wildlife Society - Oregon Chapter",
  "The Wine Group",
  "Thiele Kaolin",
  "Thiele Nordic",
  "Thiele WI",
  "Third Marine Division Association",
  "Thrivent Financial",
  "Tidewater Automobile Association",
  "Tile Contractors' Association of America",
  "Tire Industry Association",
  "Title Guaranty Escrow Services",
  "Title Guaranty of Hawaii",
  "Toledo Junior Golf Association",
  "Toledo Rowing Club",
  "Torrey Botanical Society",
  "Towing and Recovery Professionals of Iowa",
  "Traffic Club of Philadelphia",
  "Transcultural Nursing Society",
  "Transplant Recipients International Organization",
  "Transportation Club of Dallas/Fort Worth",
  "Transport Workers Union of America",
  "Tree Top",
  "Tresco Companies",
  "Triangle",
  "Triangle Fraternity",
  "Tri-County EMC",
  "Trinity Presbyterian Church",
  "Tri-State Petroleum Corporation",
  "Trout Unlimited",
  "Trucking Association of Massachusetts",
  "Truckload Carriers Association",
  "Truck Rental and Leasing Association",
  "Tube and Pipe Association",
  "Tucumcari Lodge 27 A.F. & A.M.",
  "Tulare County League of Mexican American Women",
  "Turf Equipment Technicians Association",
  "Turner Dairy",
  "Twin Cities Rubber Group",
  "TWP",
  "UAW 862",
  "UAW Local 402",
  "UDT-Seal Association",
  "UIL Academics",
  "Ukrainian Medical Association of North America",
  "Ukrainian National Association",
  "Ullman & Associates",
  "Umatilla Electric Cooperative",
  "Underwood Limited Partnership",
  "Unicold Corporation",
  "Union",
  "Union Affiliated with Rochester Regional Joint Board",
  "Union and League of Romanian Societies of America",
  "Union Elementary School",
  "Union of Needletrades, Industrial and Textile Employees (UNITE)",
  "Union of Poles in America",
  "Union Plus",
  "Union Roofing Contractors Association",
  "Union Scholars Program",
  "Unitarian",
  "Unitarian Church",
  "United Agribusiness League",
  "United American Nurses",
  "United Association of Journeymen and Apprentices of the Plumbing, Pipefitting and Sprinkler Fitting Industry",
  "United Association of Journeymen and Apprentices of the Plumbing, Pipefitting and Sprinkler Fitting Industry of the United States and Canada",
  "United Association of Plumbers & Pipefitters",
  "United Association of Plumbers & Pipefitters, Local Union 230",
  "United Automobile, Aerospace, & Agricultural Workers",
  "United Automobile Workers",
  "United Church of Christ",
  "United Church of Christ - LGBT",
  "United Commercial Travelers of America",
  "United Contractors",
  "United Cooperative",
  "United Daughters of the Confederacy",
  "United Farm Workers",
  "United Food and Commercial Workers International Union",
  "United Macedonian Diaspora",
  "United Methodist Church",
  "United Mine Workers of America",
  "United Ostomy Association",
  "United Postmasters and Managers of America",
  "United Producers",
  "United Public Service Employees Union",
  "United Puerto Rican Association",
  "United Rubber, Cork, Linoleum and Plastic Workers of America",
  "United States Army Warrant Officers Association",
  "United States Association for Blind Athletes",
  "United States Bowling Congress",
  "United States Committee on Irrigation and Drainage",
  "United States Department of Energy",
  "United States Equestrian Federation",
  "United States Field Artillery Association",
  "United States Hunter Jumper Association",
  "United States Junior Chamber of Commerce",
  "United States Pony Clubs",
  "United States Racquetball Association",
  "United States Submarine Veterans",
  "United States Synchronized Swimming",
  "United States Tennis Association",
  "United Steelworkers of America",
  "United Steelworkers of America—Aluminum, Brick and Glass Workers Division",
  "United Suffolk Sheep Association",
  "United Union of Roofers, Waterproofers and Allied Workers Local 143",
  "United University Professions",
  "Upper Midwest Endurance and Competitive Riders Association",
  "Urban League Black Scholars Program",
  "USAA Golden Eagle Club",
  "USA BMX/BMX Canada",
  "USA Boxing",
  "USA Gymnastics",
  "U.S. Army Ordnance Corps Association",
  "U.S. Army Ranger Association",
  "USA Roller Sports",
  "USA Softball",
  "USA Swimming",
  "USA Water Ski",
  "USBC League",
  "U.S. Chess Federation",
  "U.S. Coast Guard Chief Petty Officers Association",
  "U.S. Coast Guard Spouses' Association of Southeastern Connecticut",
  "U.S. Figure Skating",
  "U.S. Global Investors",
  "U.S. Hispanic Chamber of Commerce",
  "U.S. Marine Corps Combat Correspondents Association",
  "USMC/Combat Helicopter & Tiltrotor Association",
  "U.S. Mountain Ranger Association",
  "U.S. Postal Service",
  "USS America Carrier Veterans Association",
  "USS Coral Sea CVA-43 Association",
  "USS Enterprise (CVAN/CVN-65) Association",
  "USS Kitty Hawk (CV/CVA-63) Veterans Association",
  "USS Little Rock Association",
  "USS Nimitz (CVN-68) Association",
  "USS Pittsburgh",
  "U.S. Venture",
  "Utah Association for Adult, Community, and Continuing Education",
  "Utah Cattlemen's Association",
  "Utah Council of the Blind",
  "Utah Education Association",
  "Utah Nurses Association",
  "Utah Occupational Therapy Association",
  "Utah Trappers Association",
  "Ute Tribe",
  "Utility Workers Union of America",
  "Valero Services",
  "Vallejo Aquatic Club",
  "Valley View Elementary",
  "Van Buren High School",
  "Van Hoof Companies",
  "Vanlue High School",
  "Vasa Order of America",
  "Ventura County Chinese American Association",
  "Ventura County Farm Bureau",
  "Vermont Association for the Education of Young Children",
  "Vermont Association of Athletic Trainers",
  "Vermont Association of Broadcasters",
  "Vermont Farm Bureau",
  "Vermont Federation of Nurses and Health Professionals",
  "Vermont Horse Council",
  "Vermont Hunter Jumper Association",
  "Vermont Morgan Horse Association",
  "Vermont NEA",
  "Vermont Nurse Practitioners Association",
  "Vermont Organization of Nurse Leaders",
  "Vermont Police Association",
  "Vermont Principals Association",
  "Vermont Retail and Grocers Association",
  "Vermont Sheriffs' Association",
  "Vermont State Employees Association",
  "Veterans of Foreign Wars",
  "Veterans of the Vietnam War",
  "Veterinary Business Management Association",
  "VFW Auxiliary",
  "VFW Post 2326",
  "VFW District 11",
  "Vi at La Jolla Village",
  "Vi at Silverstone",
  "Victory Spouses' Club",
  "Vietnam Veteran",
  "Vietnam Veterans of America",
  "VII Corps Desert Storm Veterans Association",
  "Vi Palo Alto",
  "Virginia Academy of Nutrition and Dietetics",
  "Virginia Army/Air National Guard Enlisted Association",
  "Virginia Asphalt Association",
  "Virginia Association for Career and Technical Education Administrators",
  "Virginia Association for Health, Physical Education, Recreation and Dance",
  "Virginia Association for Pupil Transportation",
  "Virginia Association of Family and Consumer Sciences",
  "Virginia Association of School Business Officials",
  "Virginia Association of School Librarians",
  "Virginia Association of Teachers of English",
  "Virginia Aviation Business Association",
  "Virginia Bear Hunters Association",
  "Virginia Business Education Association",
  "Virginia Council of Nurse Practitioners",
  "Virginia Council of Teachers of Mathematics",
  "Virginia Farm Bureau",
  "Virginia Grain Producers Association",
  "Virginia Green Lawn Care",
  "Virginia Horse Shows Association",
  "Virginia Junior Angus Association",
  "Virginia Library Association",
  "Virginia Mayflower Society",
  "Virginia National Guard Association",
  "Virginia Nursing Students Association",
  "Virginia Occupational Therapy Association",
  "Virginia Organization of Nurse Executives and Leaders",
  "Virginia Petroleum, Convenience and Grocery Association",
  "Virginia Society for Healthcare Human Resources Administration",
  "Virginia State Firefighters Association",
  "Virginia State Reading Association",
  "Virginia Transportation Construction Alliance",
  "Virginia Water Environmental Association",
  "Virginia Wrestling Association",
  "Vista Irrigation District",
  "Visual Resources Association",
  "Vocational Industrial Clubs of America",
  "Volkswagen of America",
  "Waialua Hawaiian Civic Club",
  "Waikiki Hawaiian Civic Club",
  "Walmart",
  "Walnut Grove Community Church",
  "Ware Malcomb",
  "Washington Association for Career and Technical Education",
  "Washington Association of Educational Office Professionals",
  "Washington Career & Technical Sports Medicine Association",
  "Washington Cattlemen's Association",
  "Washington Correctional Association",
  "Washington Council of the Blind",
  "Washington Education Association",
  "Washington Farm Bureau",
  "Washington Farm Forestry Association",
  "Washington Floricultural Association",
  "Washington Game Warden Association",
  "Washington Independent Telecommunications Association",
  "Washington Journalism Education Association",
  "Washington Library Association",
  "Washington Occupational Therapy Association",
  "Washington Officials Association",
  "Washington Osteopathic Medical Association",
  "Washington Press Association",
  "Washington School Nutrition Association",
  "Washington Secondary School Athletic Administrators Association",
  "Washington State Academy of Physician Assistants",
  "Washington State Auto Dealers Association",
  "Washington State Business Education Association",
  "Washington State Coaches Association",
  "Washington State Council of Fire Fighters",
  "Washington State Dairy Women",
  "Washington State Dental Hygienists' Association",
  "Washington State Environmental Health Association",
  "Washington State Health Information Management Association",
  "Washington State Mathematics Council",
  "Washington State Nurses Association",
  "Washington State Tree Fruit Association",
  "Washington Trucking Associations",
  "Water Environment Association of Texas",
  "Water Environment Association of Utah",
  "Water Environment Federation",
  "Water Environment Federation of South Carolina",
  "Water Management Association of Ohio",
  "Waters Works Operators' Association of Pennsylvania",
  "Webster Square Business Association",
  "Weight Watchers",
  "Welch's",
  "Welsh National Gymanfa Ganu Association",
  "Welsh Sanitation Service",
  "Wenatchee Sunrise Rotary Club Challenge Program",
  "Wesleyan",
  "Western Association of Food Chains",
  "Western Association of Women Historians",
  "Western Catholic Union",
  "Western Digital",
  "Western Fairs Association",
  "Western Fraternal Life Association",
  "Western Institute of Nursing",
  "Western Museums Association",
  "Western Saddle Clubs Association",
  "Western Society of Engineers",
  "Western Sunbathing Association",
  "Westland Ward of the Church of Jesus Christ of Latter Day Saints",
  "West Michigan Kettering Co-Op Employer",
  "Westminster Presbyterian Church",
  "Westminster Village North",
  "West Point Spouses' Club",
  "West Texas Pharmacy Association",
  "West Virginia Association of Housing Agencies",
  "West Virginia Coal Industry",
  "West Virginia Library Association",
  "West Virginia Nurses Association",
  "West Virginia Occupational Therapy Association",
  "West Virginia State Patrol",
  "West Virginia Student Nurses Association",
  "West Virginia Water Environment Association",
  "Whataburger",
  "Wheeling Fire Department",
  "Wheeling Police Department",
  "Whirly-Girls International",
  "White Castle",
  "White River Electric Association",
  "Whitinsville Water",
  "Wilderness Medical Society",
  "William Penn Association",
  "Will Rogers Air National Guard Retirees Association",
  "Wilmington Country Club",
  "Wilson Ornithological Society",
  "Winnebago County Fire Department",
  "Winston-Salem Police Department",
  "Wisconsin Academy of Nutrition and Dietetics",
  "Wisconsin Academy of Physician Assistants",
  "Wisconsin Agri-Business Association",
  "Wisconsin Amusement and Music Operators",
  "Wisconsin Association for Food Protection",
  "Wisconsin Association for Home and Community Education",
  "Wisconsin Athletic Trainers Association",
  "Wisconsin Bankers Association",
  "Wisconsin Bear Hunters Association",
  "Wisconsin Buckskin Horse Association",
  "Wisconsin Business Education Association",
  "Wisconsin Cattlemen's Association",
  "Wisconsin Cheese Makers Association",
  "Wisconsin Child Care Administrators Association",
  "Wisconsin County Police Association",
  "Wisconsin Educational Media & Technology Association",
  "Wisconsin Education Association Council",
  "Wisconsin Education Association Council — Appleton Area School District",
  "Wisconsin Education Association Council — Fox Valley Technical College",
  "Wisconsin Education Association Council — Little Chute Area School District",
  "Wisconsin Education Association Council — Neenah Joint School District",
  "Wisconsin Education Association Council — School District of New London",
  "Wisconsin Farm Bureau Federation",
  "Wisconsin Health and Physical Education",
  "Wisconsin Health Information Management Association",
  "Wisconsin High School Rodeo Association",
  "Wisconsin Holstein Association",
  "Wisconsin Horse Council",
  "Wisconsin Junior Angus Association",
  "Wisconsin Library Association",
  "Wisconsin Livestock Breeders Association",
  "Wisconsin Medical Society",
  "Wisconsin National Guard Association",
  "Wisconsin National Guard Enlisted Association and Auxiliary",
  "Wisconsin Nurses Association",
  "Wisconsin Occupational Therapy Association",
  "Wisconsin Onsite Water Recycling Association",
  "Wisconsin Potato and Vegetable Growers Association",
  "Wisconsin Quarter Horse Association",
  "Wisconsin Ready Mixed Concrete Association",
  "Wisconsin School Counselor Association",
  "Wisconsin Speech-Language Pathology and Audiology Association",
  "Wisconsin State Firefighters' Association",
  "Wisconsin Trappers Association",
  "W. K. Kellogg High School Alumni",
  "Woman's Life Insurance Society",
  "Woman's Relief Corps",
  "Women Chefs and Restaurateurs",
  "Women Grocers of America",
  "Women in Animation",
  "Women in Aviation International",
  "Women in Communications",
  "Women in Corporate Aviation",
  "Women in Defense",
  "Women in Federal Law Enforcement",
  "Women in Film and Video Atlanta",
  "Women in Film/Dallas",
  "Women in Film/Seattle",
  "Women in Mining",
  "Women Nationally Active for Christ",
  "Women of Virtue",
  "Women's Caucus for the Modern Languages",
  "Women's Golf Association of Massachusetts",
  "Women's International Network of Utility Professionals",
  "Women's Jewelry Association",
  "Women Soaring Pilots Association",
  "Women's Ordination Conference",
  "Women's Tennis Association",
  "Woodmen of the World",
  "Worcester Rugby Football Club",
  "World Congress of Women Chiropractors",
  "World Federalist Movement",
  "World History Association",
  "Wound, Ostomy and Continence Nurses Society",
  "Wright-Patterson Officers' Spouses Club",
  "Writers' League of Texas",
  "WSA Fraternal Life",
  "WTS International",
  "Wyoming Auctioneers Association",
  "Wyoming Farm Bureau",
  "Wyoming Groundskeepers and Growers Association",
  "Wyoming Ground Water Association",
  "Wyoming Library Association",
  "Wyoming National Guard Association",
  "Wyoming Peace Officers Association",
  "Wyoming Stock Growers Association",
  "Wyoming Telecommunications Association",
  "Wyoming Wheat Growers Association",
  "Xerox Sales Agency",
  "Yadkinville County Association of Educators",
  "Yakima Valley Growers-Shippers Association",
  "YMCA",
  "Young American Bowling Alliance",
  "Young Cattlemen's Association",
  "Youngstown Steel Equipment Sales",
  "Youth Rodeo Association",
  "Yuba-Sutter Farm Bureau",
  "YWCA of Clark County",
  "Y-W Electric Association",
  "Zonta International",
  "Zoroastrian",
];

export const indirectRelationOptions = [
  "Child Of",
  "Customer Of",
  "Dependent Of",
  "Descendant Of",
  "Employee Of",
  "Family Of",
  "Member Of",
  "Parent Of",
  "Spouse Of",
];
